import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  OnDestroy,
  Renderer2,
  ViewChild
} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl} from '@angular/forms';
import {catchError, debounceTime, distinctUntilChanged, filter, finalize, first, skip, tap} from 'rxjs/operators';
import swal, {SweetAlertOptions} from 'sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {iClient} from '../../Model/ClientModel';
import {InsuranceService, PlanSearchScope, BenefitDomain} from '../../Services/insurance.service';
import {jwtDecode} from 'jwt-decode';
import {PatientService} from '../../Services/patient.service';
import {DatePipe} from '@angular/common';
import {iProvider} from '../../Model/Provider';
import {EMPTY, merge, Subscription} from 'rxjs';
import {ProviderService} from '../../Services/provider.service';
import { Location } from '@angular/common';
import {group} from '@angular/animations';
import {MatDialog} from "@angular/material/dialog";
import {ProviderListModalComponent} from "./provider-list-modal/provider-list-modal.component";

declare var $: any;
type Question = {
  benefitDomain?: BenefitDomain;
  id: number | string;
  question: string;
  category: string;
  percent?: any;
  limitation?: any;
  disclaimers?: any;
  age?: any;
};
type EligibilityEnum =
  | 'PATIENT_INFO'
  | 'MAX_DEDUCTIBLES'
  | 'CO_INSURANCE'
  | 'COVERAGE_FREQUENCY'
  | 'ORTHO'
  | 'HISTORY';
type VerificationResultKey =
  | 'CoInsurance'
  | 'Coverage'
  | 'Ortho'
  | 'Appointment'
  | 'MaxDeductible'
  | 'History';
  type VerificationStatus = 'VERIFIED' | 'PENDING' | 'ERROR';
@Component({
  selector: 'pm-userworkarea',
  templateUrl: './userworkarea.component.html',
  styleUrls: ['./userworkarea.component.css'],
  providers: [DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class UserworkareaComponent implements OnInit, OnDestroy  {
  isEditable = true;
  dataExists = false; // Flag to control button display
  coverageExists = false; // Flag to control button display
  InsuranceExists = false;
  coinsuranceExists = false;
  orthoExists = false;
  historyExists = false;
  allHistFieldsFilled = false;
  allFieldsFilled = false;
  allCoFieldsFilled = false;
  allMaxFieldsFilled = false;
  allCoverageFieldsFilled = false;
  allOrthoFieldsFilled = false;
  isPatientFormInitialized = false;
  isMaxFormInitialized = false;
  isCoFormInitialized = false;
  isCoverageFormInitialized = false;
  isOrthoFormInitialized = false;
  isHistoryFormInitialized = false;
  isFormDisabled = false;
  disableMaxColumns = true;
  verificationFormEditable = false;
  resizingColumn: any;
  startX: number;
  startWidth: number;
  previousUrl: string | null = null;
  patientForm: FormGroup;
  pInsuranceForm: FormGroup;
  insuranceCoveragesForm: FormGroup;
  orthoForm: FormGroup;
  historyForm: FormGroup;
  insuranceVerifyForm: FormGroup;
  coinsuranceForm: FormGroup;
  viewMode: any;
  getPatientFormData: any;
  clientId: any;
  patientId: any;
  officeId: any;
  planCreation: string;
  status: any;
  isFocused: boolean[] = [];
  displayedColumns: string[] = ['procedureName', 'procedureInput']; // Define table columns
  maxColumns: string[] = ['maxName', 'maxInput', 'maxCoverage', 'maxPlan', 'maxService'];
  coverageColumns: string[] = ['procedure', 'percentage', 'frequency', 'guidelines', 'agelimit'];
  historyColumns: string[] = ['historyName', 'historyInput', 'historyEligibility'];
  coinsuranceColumns: string[] = ['coinsurance', 'percent', 'waitingPeriod','deductible'];
  orthoColumns: string[] = ['ortho', 'orthoPercent', 'orthoFrequency', 'orthoGuidelines', 'age'];
  proceduresData = [];
  maxData = [];
  coveragesData = [];
  coinsuranceData = [];
  orthoData = [];
  verificationData: any[] = [];
  historyData = [];
  groupIds: string[] = [];
  OfficeType: any = [];
  providerType: any = [];
  selectedProviderObj: any = null;
  shortFormSelected = false;
  notEligilbleSelected = false;
  payerArray: any[] = [];
  filteredPayers: any[] = [];
  selectedPayer: any = null;
  payerSearchControl = new FormControl('');
  private readonly MAX_PAYER_RESULTS = 50;
  PayerId: string | null = null;
  payerSearchLoading = false;
  isVertical = false;
  private readonly layoutPreferenceKey = 'userworkarea_layout';
  isChangingLayout = false;
  private layoutChangeTimeout: any = null;
  isHidden = true;
  waitingPeriodEnabled = false;
  benefitDomain: BenefitDomain = 'DENTAL';
  planSearchDomain: BenefitDomain = 'DENTAL';
  private domainRequestId = 0;
  isQuestionReloading = false;
  questionLoadError: string | null = null;
  noQuestionsForDomain = false;
  groupSearchText: string = '';
  groupSearchScope: PlanSearchScope = 'CLIENT';
  private selectedPlanScope: PlanSearchScope = 'CLIENT';
  private groupSearchSubscription: Subscription | null = null;
  private planLookupSubscription: Subscription | null = null;
  groupSearchLoading = false;
  groupResults: any[] = [];
  searchedOnce = false;
  groupSearchErrorMsg: string | null = null;
  showGroupSearch = false;
  copiedCoverageRow: any = null;
  copiedOrthoRow: any = null;
  copiedAppointmentRow: any = null;
  copiedMaxRow: any = null;
  copiedCoInsuranceRow: any = null;
  copiedHistoryRow: any = null;
  private suppressVerificationApi = false;
  timerDisplay = '00:00:00';
  private timerInterval: any = null;
  private timerStartedAt: number | null = null;
  private elapsedBeforeStart = 0;
  private timerStopped = false;
  private auditSubmissionSent = false;
  activeAuditChangeRequest: any = null;
  auditChangeRequestLoading = false;
  private auditChangeRequestVersion = 0;
  private auditSubmissionInProgress: Promise<'not-ready' | 'success' | 'already-submitted' | 'failed'> | null = null;
  @ViewChild('modalSearchBox') modalSearchBox!: ElementRef<HTMLInputElement>;
  @HostListener('document:keydown', ['$event'])
  onGlobalKeyDown(event: KeyboardEvent): void {
    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    if (
      ctrlOrCmd &&
      event.shiftKey &&
      event.key.toLowerCase() === 's'
    ) {
      event.preventDefault();
      event.stopPropagation();

      // Prevent multiple saves while keys are held
      if (event.repeat) {
        return;
      }

      // Don't save in patient/view-only mode
      if (
        this.viewMode === 'patient' ||
        !this.verificationFormEditable
      ) {
        return;
      }

      this.onallSave();
    }
  }

  insuranceNameOptions: string[] = [
    'Aetna KY',
    'Aetna DENTAL ACCESS',
    'AmeriHealth PA',
    'Ameritas NE',
    'Anthem Blue Cross Blue Shield',
    'Assurant OH',
    'Benecare PA',
    'Blue Cross / Blue Shield IL IL',
    'BLUE CROSS BLUE SHEILD SC SC',
    'Blue Cross Blue Shield IL',
    'Blue Cross Blue Shield MA MA',
    'Blue Cross Blue Shield MN',
    'Blue Cross Blue Shield PA',
    'Blue Cross Blue Shield TX',
    'Blue Cross Dental IL',
    'blue cross dental MN',
    'BLUECROSS BLUESHIELD ALABAMA AL',
    'BlueCross BlueShield Tenn TN',
    'CAREFIRST BLUE CROSS KY',
    'Careington TX',
    'Carpenter\'s H & W Fund PA',
    'Chesapeake Life Insurance Company TX',
    'Cigna TN',
    'Delta Dental Of AR AR',
    'Delta Dental Of CA CA',
    'Delta Dental Of CO',
    'Delta Dental Of GA GA',
    'Delta Dental of HI HI',
    'Delta Dental Of ID ID',
    'Delta Dental Of IL IL',
    'Delta Dental Of KS KS',
    'Delta Dental Of MA WI',
    'Delta Dental Of MI MI',
    'Delta Dental Of MN MN',
    'Delta Dental Of MO MO',
    'Delta Dental Of NJ NJ',
    'Delta Dental Of North East NH',
    'Delta Dental Of NY PA',
    'Delta Dental Of PA PA',
    'Delta Dental Of RI RI',
    'Delta Dental Of TN TN',
    'Delta Dental Of VA VA',
    'Delta Dental Of WA WA',
    'Delta Dental Of WI WI',
    'Delta of Alpharetta GA',
    'DENTEGRA GA',
    'District 1201 Health & Welfare fund PA',
    'Doctors nETWORK',
    'DOMINION NATIONAL VA',
    'EMI HEALTH UT',
    'FEP BLUE DENTAL MN',
    'Fidelio PA',
    'Frank Vacarro NJ',
    'GEHA MO',
    'Guardian TX',
    'Health Now PA',
    'Highmark Blue Shiield PA',
    'Horizon BC/BC NJ MN',
    'Humana One KY',
    'Independance BC/BS PA',
    'L.E.H.B PA',
    'LIBERTY DENTAL PLAN NV',
    'Liberty Mutual Ins Co',
    'LINCOLN FINANCIAL GRP FL',
    'Local 152 NJ',
    'Local 169 PA',
    'Local 1776 PA',
    'Local 634 PA',
    'Local 929 PA',
    'Local 98 NJ',
    'Louis Mattucci PA',
    'LPMA PA',
    'Mail Administrators KY',
    'MetLife Dental TX',
    'MUTUAL OF OMAHA IN',
    'Physicians Mutual Insurance Company NE',
    'Principal Life Insurance IA',
    'Progress PA',
    'R G A WA',
    'Regence BCBS of Oregon ID',
    'Reliance Standard Life Ins Co NE',
    'RENAISSANCE IN',
    'STATE FARM GA',
    'SUN LIFE FINANCIAL IA',
    'Teamcare IL',
    'Teamster H&W 830 PA',
    'Teamster H&W PA',
    'TEAMSTER LOCAL 830 PA19114',
    'Teamsters H&W Fund NJ',
    'The Standard NE',
    'Travelers Ins Co. NJ',
    'UCCI PA',
    'UNI-CARE 200',
    'UNITED CONCORDIA - TRICARE PA',
    'UNITED CONCORDIA HMO BLUE',
    'United Healthcare Community Plan WI',
    'United Healthcare UT',
    'UNUM LA'
  ];

  nType: any = [
    {value: 'selectNetwork', viewValue: 'Select Network Type'},
    {value: 'In-Network', viewValue: 'IN Network'},
    {value: 'Out-Of-Network', viewValue: 'Out Network'},
  ];

  creationType: any = [
    {value: 'YES', viewValue: 'Yes'},
    {value: 'NO', viewValue: 'No'},
    {value: 'NEED PLAN', viewValue: 'Need Plan'},
  ];

  pType: any = [
    {value: 'selectPlan', viewValue: 'Select Plan Type'},
    {value: 'HMO', viewValue: 'HMO'},
    {value: 'DISCOUNT', viewValue: 'DISCOUNT'},
    {value: 'PPO', viewValue: 'PPO'},
    {value: 'SPPO', viewValue: 'SPPO'},
    {value: 'REVERIFICATION', viewValue: 'RE VERIFICATION'},
    {value: 'NOT ELIGIBLE', viewValue: 'NOT ELIGIBLE'},
    {value: 'ELIGIBLE', viewValue: 'ELIGIBLE'},
    {value: 'CNID', viewValue: 'CNID'},
    {value: 'TPI', viewValue: 'TPI'},
    {value: 'PREMIER', viewValue: 'PREMIER'},
    // {value: 'MEDICAID', viewValue: 'MEDICAID'},
    // {value: 'MEDICARE', viewValue: 'MEDICARE'},
    {value: 'EPO', viewValue: 'EPO'},
    {value: 'NEED_UPDATE', viewValue: 'NEED UPDATE'},
    // {value: 'ELLIG_CHECK', viewValue: 'ELIG CHECK'},
  ];

  fType: any = [
    {value: 'selectForm', viewValue: 'Select Form Type'},
    {value: 'FULL FORM', viewValue: 'FULL FORM'},
    {value: 'SHORT FORM', viewValue: 'SHORT FORM'},
    {value: 'ELIG CHECK', viewValue: 'ELIG CHECK'},
  ];

  sectionResults: { [key: string]: 'success' | 'error' | null } = {
    coinsurance: null,
    coverage: null,
    ortho: null,
    appointment: null,
    maxDeductible: null,
    history: null
  };

  verificationResults: { [key: string]: 'VERIFIED' | 'PENDING' | 'ERROR' | null } = {
    CoInsurance: null,
    Coverage: null,
    Ortho: null,
    Appointment: null,
    MaxDeductible: null,
    History: null
  };



  constructor(private fb: FormBuilder,
              private insuranceService: InsuranceService,
              private patientService: PatientService,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute,
              private renderer: Renderer2,
              private elRef: ElementRef,
              private datePipe: DatePipe,
              private location: Location,
              private route: Router,
              private providerServices: ProviderService,
              private dialog: MatDialog,
              private cdr: ChangeDetectorRef,
              private ngZone: NgZone) {

    this.patientId = this.activatedRoute.snapshot.paramMap.get('id');
    this.viewMode = this.activatedRoute.snapshot.queryParams.form;
    this.officeId = this.activatedRoute.snapshot.queryParamMap.get('officeId');
    this.planCreation = this.activatedRoute.snapshot.queryParamMap.get('planCreation');


    this.patientForm = this.fb.group({
      insuranceProvider: [null, Validators.required],
      insuranceProviderName: [null],
      memberId: [null, Validators.required],
      officeId: [null],
      provider: [null],
      memberDob: [null],
      patientDob: [null],
      patientName: [null],
      patientLastName: [null],
      employerName: [null, Validators.required],
      groupId: [null, Validators.required],
      insurancePhoneNumber: [null, Validators.pattern(/^\d{10}$|^\d{3}-\d{3}-\d{4}$/)],
      remarks: [null],
      notes: [null],
      planCreation: [null],
      networkType: ['In-Network'],
      planType: [null],
      formType: ['FULL FORM'],
      planName: [null]
    });


    this.insuranceCoveragesForm = this.fb.group({
      procedures: this.fb.array(this.coveragesData.map(procedure => this.fb.group({
        // coverage: [null],
        percentage: [null],
        frequency: [null],
        guidelines: [null],
        // agehighvalue: [null],
        agelowvalue: [null]
        // history: [null]
      })))
    });

    this.orthoForm = this.fb.group({
      orthos: this.fb.array(this.orthoData.map(ortho => this.fb.group({
        // orthoCoverage: [null],
        orthoPercent: [null],
        orthoFrequency: [null],
        orthoGuidelines: [null],
        age: [null],
        // orthoHistory: [null],
      })))
    });

    this.coinsuranceForm = this.fb.group({
      coinsurances: this.fb.array(this.coinsuranceData.map(coinsurance => this.fb.group({
        // coverageLevel: [null],
        percent: [null],
        waitingPeriod: [null],
        deductible: [null],
        // message: [null]
      })))
    });

    // Initialize the form group dynamically for each procedure
    this.pInsuranceForm = this.fb.group({
      maximumInput: this.fb.array(this.maxData.map(maxName => this.fb.group({
        maxInput: [null],
        maxCoverage: [null],
        maxPlan: [null],
        maxService: [null],
      })))
    });
    this.insuranceVerifyForm = this.fb.group({
      proceduresInput: this.fb.array(this.proceduresData.map(procedureName => this.fb.group({
        procedureInput: [null]
      })))
    });
    this.historyForm = this.fb.group({
      historiesInput: this.fb.array(this.historyData.map(historyName => this.fb.group({
        historyInput: [null],
        historyEligibility : [null]
      })))
    });

    const formatDateToYYYYMMDD = (dateString: string): Date | null => {
      if (!dateString) {
        return null;
      } // Handle null or undefined
      const [month, day, year] = dateString.split('-'); // Assuming MM-DD-YYYY format
      return new Date(Number(year), Number(month) - 1, Number(day), 12); // Rearrange to YYYY-MM-DD
    };

    const mapNetworkType = (apiValue: string | null): string => {
      if (!apiValue || apiValue.trim() === '') {
        return 'In-Network'; // Default to In-Network for null, undefined, or empty string
      }
      if (apiValue === 'In-Network' || apiValue === 'inNetwork') {
        return 'In-Network';
      } else if (apiValue === 'Out-Of-Network' || apiValue === 'outNetwork') {
        return 'Out-Of-Network';
      }
      return apiValue || 'In-Network'; // Default to In-Network
    };

    if (this.patientId) {
      const reqData: any = {
        patientId: this.patientId,
        clientId: this.authService.clientId
      };

      this.patientService.getAllPatients(reqData).pipe(first()).subscribe(
        (response: any) => {
          if (response != undefined) {
            this.getPatientFormData = response;
            const data = response;
            this.status = data.active;
            if (this.payerArray !== []) {
              this.patientForm.patchValue({
                patientName: data.firstName || null,
                patientLastName: data.lastName || null,
                insuranceProvider: data.primaryIns?.payer?.id ? data.primaryIns?.payer?.id : data.secondaryIns?.payer?.id ? data.secondaryIns?.payer?.id : null,
                insuranceProviderName: data.payerName || null,
                memberId: data.memberId || null,
                officeId: data.officeId ? data.officeId :  null,
                provider: data.providerName ? data.providerName : null,
                memberDob: formatDateToYYYYMMDD(data.subscriber?.dob) ? formatDateToYYYYMMDD(data.subscriber?.dob) : null,
                patientDob: formatDateToYYYYMMDD(data.dob) || null,
                employerName: data.primaryIns?.employerName ? data.primaryIns?.employerName : data.secondaryIns?.employerName ? data.secondaryIns?.employerName : null,
                groupId: data.primaryIns?.groupNo ? data.primaryIns?.groupNo : data.secondaryIns?.groupNo ? data.secondaryIns?.groupNo : null,
                insurancePhoneNumber: data.primaryIns?.contact?.phones?.[0]?.number ? data.primaryIns?.contact?.phones?.[0]?.number : data.secondaryIns?.contact?.phones?.[0]?.number ? data.secondaryIns?.contact?.phones?.[0]?.number : null,
                planCreation:
                  data.primaryIns?.planCreation !== undefined && data.primaryIns?.planCreation !== null
                    ? data.primaryIns.planCreation
                    : data.secondaryIns?.planCreation !== undefined && data.secondaryIns?.planCreation !== null
                    ? data.secondaryIns.planCreation
                    : null,
                networkType: mapNetworkType(data.primaryIns?.networkType ? data.primaryIns?.networkType : data.secondaryIns?.networkType ? data.secondaryIns?.networkType : 'In-Network'),
                planType: data.primaryIns?.planType ? data.primaryIns?.planType : data.secondaryIns?.planType ? data.secondaryIns?.planType : 'PPO',
                formType: data.primaryIns?.formType ? data.primaryIns?.formType : data.secondaryIns?.formType ? data.secondaryIns?.formType : 'FULL FORM',
                planName: data.primaryIns?.planName ? data.primaryIns?.planName : data.secondaryIns?.planName ? data.secondaryIns?.planName : null,
                remarks: data.remarks || null,
                notes: data.notes || null,
              });
              this.PayerId = data.primaryIns?.payer?.payerIdCode ? data.primaryIns?.payer?.payerIdCode : data.secondaryIns?.payer?.payerIdCode ? data.secondaryIns?.payer?.payerIdCode : null;
              // ✅ Call this AFTER patching planType
              const initialPlanType = this.patientForm.get('planType')?.value;
              // console.log('PlanType:', initialPlanType);
              if (initialPlanType) {
                this.onPlanTypeChange(initialPlanType);
              }
            }
          } else {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response.message,
              showConfirmButton: false,
              timer: 5000
            });
          }
        },
        (error) => {
          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error.error.message,
            showConfirmButton: false,
            timer: 5000
          });
        }
      );
    }

  }
  // Minimal helpers
  private normalize(str: string | null | undefined): string {
    return (str || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  // Show dropdown only for this question (case/space-insensitive)
  isInsuranceName = (q: string) => this.normalize(q) === 'insurance name';
  // Check if the question is "PAYER ID" (disable the input)
  isPayerId = (q: string) => this.normalize(q) === 'payer id';

  ngOnInit(): void {
    const initialDomain = this.activatedRoute.snapshot.queryParamMap.get('domain')?.toUpperCase();
    this.benefitDomain = initialDomain === 'MEDICAL' ? 'MEDICAL' : 'DENTAL';
    this.planSearchDomain = this.benefitDomain;
    this.loadAuditChangeRequestsForDomain();
    this.isEditable = this.activatedRoute.snapshot.data.isEditable ?? true;
    this.initializePayerSearch();
    // this.onIns();
    // Initialize all forms first without triggering API calls
    // this.initializeAllForms();
    // Single method to handle initial loading
    this.registerAndLoadPatientData();

    // Setup form listeners first (before any data loading)
    this.setupFormListeners();

    // Fetch verification data only once
    this.fetchVerificationData();

    // Office data loading (independent)
    this.loadOfficeData();


    // Retrieve the previous route from the navigation state
    if (history.state && history.state.from) {
      this.previousUrl = history.state.from;
    }

    // this.updateLayout(this.authService.clientId);
    this.loadLayoutPreference();
    this.HiddenColoumn();
    this.startVerificationTimer();
    document.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  ngOnDestroy(): void {
  this.groupSearchSubscription?.unsubscribe();
  this.planLookupSubscription?.unsubscribe();
  this.pauseVerificationTimer();
  document.removeEventListener(
    'visibilitychange',
    this.onVisibilityChange
  );

  if (this.layoutChangeTimeout) {
    clearTimeout(this.layoutChangeTimeout);
  }
  }

  private get timerStorageKey(): string {
  return `verification_timer_${this.patientId}`;
  }
  private getCurrentTimerSeconds(): number {
  const runningMs = this.timerStartedAt ? Date.now() - this.timerStartedAt : 0;
  return Math.floor((this.elapsedBeforeStart + runningMs) / 1000);
  }
  private startVerificationTimer(): void {
  if (!this.patientId) return;

  const saved = sessionStorage.getItem(this.timerStorageKey);
  if (saved) {
    const parsed = JSON.parse(saved);
    this.elapsedBeforeStart = parsed.elapsedBeforeStart || 0;
    this.timerStopped = parsed.timerStopped || false;
  }

  this.updateTimerDisplay();

  if (this.timerStopped || this.timerInterval) return;

  this.timerStartedAt = Date.now();

  this.timerInterval = setInterval(() => {
    this.updateTimerDisplay();
  }, 1000);
  }
  private stopVerificationTimerOnly(): void {
    this.pauseVerificationTimer();
    this.timerStopped = true;

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }

    this.saveTimerSession();
    this.updateTimerDisplay();
    this.cdr.markForCheck();
  }

  private saveTimerSession(): void {
    sessionStorage.setItem(this.timerStorageKey, JSON.stringify({
      elapsedBeforeStart: this.elapsedBeforeStart,
      timerStopped: this.timerStopped
    }));
  }

  private pauseVerificationTimer(): void {
    if (this.timerStartedAt) {
      this.elapsedBeforeStart += Date.now() - this.timerStartedAt;
      this.timerStartedAt = null;
    }

    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }

    this.saveTimerSession();
  }

// private async stopVerificationTimerAndSendToApi(): Promise<void> {
//   this.pauseVerificationTimer();

//   const totalSeconds = Math.floor(this.elapsedBeforeStart / 1000);

//   try {
//     await this.insuranceService
//       .saveVerificationTime({
//         patientId: this.patientId,
//         time: totalSeconds,
//         isTimer: true
//       })
//       .pipe(first())
//       .toPromise();

//     this.timerStopped = true;

//     if (this.timerInterval) {
//       clearInterval(this.timerInterval);
//       this.timerInterval = null;
//     }

//     localStorage.setItem(this.timerStorageKey, JSON.stringify({
//       elapsedBeforeStart: this.elapsedBeforeStart,
//       timerStopped: true
//     }));

//     this.updateTimerDisplay();
//     this.cdr.markForCheck();
//   } catch (error) {
//     console.error('Timer API failed:', error);
//   }
// }

  private saveTimerLocal(): void {
    localStorage.setItem(this.timerStorageKey, JSON.stringify({
      elapsedBeforeStart: this.elapsedBeforeStart,
      timerStopped: this.timerStopped
    }));
  }

  private updateTimerDisplay(): void {
    const totalSeconds = this.getCurrentTimerSeconds();

    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    this.timerDisplay = `${this.pad2(h)}:${this.pad2(m)}:${this.pad2(s)}`;

    sessionStorage.setItem(this.timerStorageKey, JSON.stringify({
      elapsedBeforeStart: this.elapsedBeforeStart + (this.timerStartedAt ? Date.now() - this.timerStartedAt : 0),
      timerStopped: this.timerStopped
    }));

    this.cdr.markForCheck();
  }

  private pad2(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  private onVisibilityChange = (): void => {
    if (document.hidden) {
      this.pauseVerificationTimer();
    } else {
      this.startVerificationTimer();
    }
  };

  
  // Audit results arrive on saved answer objects, while table rows originate
  // from questionnaire configuration. Attach the feedback without changing forms.
  private setQuestionAuditFeedback(question: any, answer: any): void {
    if (!question) return;
    question.auditStatus = answer?.auditStatus || null;
    question.auditDetails = Array.isArray(answer?.auditDetails)
      ? answer.auditDetails
      : [];
  }

  isAuditFailed(question: any): boolean {
    const status = String(question?.auditStatus || '').toUpperCase();
    if (status) return status === 'FAIL';
    return Array.isArray(question?.auditDetails) &&
      question.auditDetails.some((item: any) =>
        String(item?.status || '').toUpperCase() === 'FAIL'
      );
  }

  auditFailureCount(questions: any[]): number {
    return Array.isArray(questions)
      ? questions.filter(question => this.isAuditFailed(question)).length
      : 0;
  }

  auditFailureTooltip(question: any): string {
    if (!this.isAuditFailed(question)) return '';
    const failures = (Array.isArray(question?.auditDetails) ? question.auditDetails : [])
      .filter((item: any) => String(item?.status || '').toUpperCase() === 'FAIL');
    const questionId = Number(question?.id);
    const label = String(question?.name || question?.serviceName || '').trim().toUpperCase();
    const detail = failures.find((item: any) => questionId && Number(item.questionId) === questionId) ||
      failures.find((item: any) => String(item?.question || '').trim().toUpperCase() === label) ||
      failures.slice().sort((a: any, b: any) =>
        String(b.auditedAt || '').localeCompare(String(a.auditedAt || ''))
      )[0];
    const remark = String(detail?.remark || '').trim() || 'No auditor remark provided.';
    const parts = ['Audit Changes Requested', 'Remark: ' + remark];
    if (detail?.expectedValue !== undefined && detail.expectedValue !== null &&
        String(detail.expectedValue).trim()) {
      parts.push('Expected: ' + String(detail.expectedValue));
    }
    if (detail?.severity) parts.push('Severity: ' + detail.severity);
    return parts.join('\\n');
  }

  private refreshQuestionsView(): void {
    this.ngZone.run(() => {
      this.proceduresData = [...this.proceduresData];
      this.maxData = [...this.maxData];
      this.coveragesData = [...this.coveragesData];
      this.coinsuranceData = [...this.coinsuranceData];
      this.orthoData = [...this.orthoData];
      this.historyData = [...this.historyData];

      // this.cdr.markForCheck();
      this.cdr.detectChanges();
    });
  }

  goBack() {
    if (this.previousUrl) {
      this.route.navigateByUrl(this.previousUrl);
    } else {
      this.location.back(); // Default back behavior
    }
  }

  trackById(index: number, row: any): any {
    return row?.id ?? row?.serviceName ?? row?.name ?? index;
  }

  // Fields to copy for each section
private readonly coverageCopyFields: string[] = [
  'percentage',
  'frequency',
  'guidelines',
  'agelowvalue'
  // 'agehighvalue' // add later if needed
];

private readonly orthoCopyFields: string[] = [
  'orthoPercent',
  'orthoFrequency',
  'orthoGuidelines',
  'age'
];

private readonly appointmentCopyFields: string[] = [
  'procedureInput'
];

private readonly maxCopyFields: string[] = [
  'maxInput',
  'maxCoverage',
  'maxPlan',
  'maxService'
];

private readonly coInsuranceCopyFields: string[] = [
  'percent',
  'waitingPeriod',
  'deductible'
];

private readonly historyCopyFields: string[] = [
  'historyInput',
  'historyEligibility'
];

/**
 * Generic helper to get row data from a FormArray based on field list
 */
private getRowValue(formArray: FormArray, index: number, fields: string[]): any {
  const row = formArray.at(index);
  const data: any = {};

  fields.forEach((field) => {
    data[field] = row.get(field)?.value ?? null;
  });

  return data;
}

/**
 * Generic helper to patch row data into a FormArray row
 */
private applyRowValue(formArray: FormArray, index: number, data: any): void {
  const row = formArray.at(index);

  this.suppressVerificationApi = true;

  row.patchValue(data, { emitEvent: false });
  row.markAsDirty();
  row.markAsTouched();
  row.updateValueAndValidity({ emitEvent: false });

  Promise.resolve().then(() => {
    this.suppressVerificationApi = false;
  });
}

/**
 * Prevent shortcut from interfering when user is selecting text
 * inside input or textarea.
 */
private userIsSelectingTextInEditable(event: KeyboardEvent): boolean {
  const el = event.target as HTMLInputElement | HTMLTextAreaElement | null;

  if (!el) return false;

  const tag = el.tagName?.toLowerCase();
  if (tag !== 'input' && tag !== 'textarea') return false;

  const start = el.selectionStart;
  const end = el.selectionEnd;

  return typeof start === 'number' && typeof end === 'number' && start !== end;
}

/**
 * Optional helper:
 * if row is disabled, skip copy / paste actions
 */
private isRowDisabled(formArray: FormArray, index: number): boolean {
  return formArray.at(index)?.disabled ?? false;
}

// =========================
// Appointment Section
// =========================
  onAppointmentRowKeydown(event: KeyboardEvent, rowIndex: number): void {
    if (this.userIsSelectingTextInEditable(event)) return;

    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    // Ctrl + D -> copy current column only from previous row
    if (ctrlOrCmd && !event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.proceduresInput, rowIndex)) return;

      const controlName = this.getControlNameFromElement(event.target);
      if (!controlName) return;

      const previousRow = this.proceduresInput.at(rowIndex - 1);
      const previousValue = previousRow.get(controlName)?.value;

      this.applySingleControlValue(this.proceduresInput, rowIndex, controlName, previousValue);
      return;
    }

    // Ctrl + Shift + D -> copy full previous row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.proceduresInput, rowIndex)) return;

      const previousRowData = this.getRowValue(
        this.proceduresInput,
        rowIndex - 1,
        this.appointmentCopyFields
      );

      this.applyRowValue(this.proceduresInput, rowIndex, previousRowData);
      return;
    }

    // Ctrl + Shift + C
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      event.stopPropagation();

      this.copiedAppointmentRow = this.getRowValue(
        this.proceduresInput,
        rowIndex,
        this.appointmentCopyFields
      );
      return;
    }

    // Ctrl + Shift + V
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      event.stopPropagation();

      if (!this.copiedAppointmentRow) return;
      if (this.isRowDisabled(this.proceduresInput, rowIndex)) return;

      this.applyRowValue(this.proceduresInput, rowIndex, this.copiedAppointmentRow);
      return;
    }
  }
// =========================
// Max Section
// =========================
  onMaxRowKeydown(event: KeyboardEvent, rowIndex: number): void {
    if (this.userIsSelectingTextInEditable(event)) return;

    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    // Ctrl + D -> copy current column only from previous row
    if (ctrlOrCmd && !event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.maximumInput, rowIndex)) return;

      const controlName = this.getControlNameFromElement(event.target);
      if (!controlName) return;

      const previousRow = this.maximumInput.at(rowIndex - 1);
      const previousValue = previousRow.get(controlName)?.value;

      this.applySingleControlValue(this.maximumInput, rowIndex, controlName, previousValue);
      return;
    }

    // Ctrl + Shift + D -> copy full previous row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.maximumInput, rowIndex)) return;

      const previousRowData = this.getRowValue(
        this.maximumInput,
        rowIndex - 1,
        this.maxCopyFields
      );

      this.applyRowValue(this.maximumInput, rowIndex, previousRowData);
      return;
    }

    // Ctrl + Shift + C
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      event.stopPropagation();

      this.copiedMaxRow = this.getRowValue(
        this.maximumInput,
        rowIndex,
        this.maxCopyFields
      );
      return;
    }

    // Ctrl + Shift + V
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      event.stopPropagation();

      if (!this.copiedMaxRow) return;
      if (this.isRowDisabled(this.maximumInput, rowIndex)) return;

      this.applyRowValue(this.maximumInput, rowIndex, this.copiedMaxRow);
      return;
    }
  }
// =========================
// Coinsurance Section
// =========================
  onCoInsuranceRowKeydown(event: KeyboardEvent, rowIndex: number): void {
    if (this.userIsSelectingTextInEditable(event)) return;

    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    // Ctrl + D -> copy current column only from previous row
    if (ctrlOrCmd && !event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.coinsurances, rowIndex)) return;

      const controlName = this.getControlNameFromElement(event.target);
      if (!controlName) return;

      const previousRow = this.coinsurances.at(rowIndex - 1);
      const previousValue = previousRow.get(controlName)?.value;

      this.applySingleControlValue(this.coinsurances, rowIndex, controlName, previousValue);
      return;
    }

    // Ctrl + Shift + D -> copy full previous row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.coinsurances, rowIndex)) return;

      const previousRowData = this.getRowValue(
        this.coinsurances,
        rowIndex - 1,
        this.coInsuranceCopyFields
      );

      this.applyRowValue(this.coinsurances, rowIndex, previousRowData);
      return;
    }

    // Ctrl + Shift + C
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      event.stopPropagation();

      this.copiedCoInsuranceRow = this.getRowValue(
        this.coinsurances,
        rowIndex,
        this.coInsuranceCopyFields
      );
      return;
    }

    // Ctrl + Shift + V
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      event.stopPropagation();

      if (!this.copiedCoInsuranceRow) return;
      if (this.isRowDisabled(this.coinsurances, rowIndex)) return;

      this.applyRowValue(this.coinsurances, rowIndex, this.copiedCoInsuranceRow);
      return;
    }
  }
// =========================
// Coverage Section
// =========================

  onCoverageRowKeydown(event: KeyboardEvent, rowIndex: number): void {
    if (this.userIsSelectingTextInEditable(event)) return;

    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    // Ctrl + D -> copy only current column from previous row
    if (ctrlOrCmd && !event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.procedures, rowIndex)) return;

      const controlName = this.getControlNameFromElement(event.target);
      if (!controlName) return;

      const previousRow = this.procedures.at(rowIndex - 1);
      const previousValue = previousRow.get(controlName)?.value;

      this.applySingleControlValue(this.procedures, rowIndex, controlName, previousValue);
      return;
    }

    // Ctrl + Shift + D -> copy full previous row into current row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.procedures, rowIndex)) return;

      const previousRowData = this.getRowValue(
        this.procedures,
        rowIndex - 1,
        this.coverageCopyFields
      );

      this.applyRowValue(this.procedures, rowIndex, previousRowData);
      return;
    }

    // Ctrl + Shift + C -> copy current full row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      event.stopPropagation();

      this.copiedCoverageRow = this.getRowValue(
        this.procedures,
        rowIndex,
        this.coverageCopyFields
      );
      return;
    }

    // Ctrl + Shift + V -> paste copied full row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      event.stopPropagation();

      if (!this.copiedCoverageRow) return;
      if (this.isRowDisabled(this.procedures, rowIndex)) return;

      this.applyRowValue(this.procedures, rowIndex, this.copiedCoverageRow);
      return;
    }
  }

// =========================
// Ortho Section
// =========================

  onOrthoRowKeydown(event: KeyboardEvent, rowIndex: number): void {
    if (this.userIsSelectingTextInEditable(event)) return;

    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    // Ctrl + D -> copy current column only from previous row
    if (ctrlOrCmd && !event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.orthos, rowIndex)) return;

      const controlName = this.getControlNameFromElement(event.target);
      if (!controlName) return;

      const previousRow = this.orthos.at(rowIndex - 1);
      const previousValue = previousRow.get(controlName)?.value;

      this.applySingleControlValue(this.orthos, rowIndex, controlName, previousValue);
      return;
    }

    // Ctrl + Shift + D -> copy full previous row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.orthos, rowIndex)) return;

      const previousRowData = this.getRowValue(
        this.orthos,
        rowIndex - 1,
        this.orthoCopyFields
      );

      this.applyRowValue(this.orthos, rowIndex, previousRowData);
      return;
    }

    // Ctrl + Shift + C -> copy current row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      event.stopPropagation();

      this.copiedOrthoRow = this.getRowValue(
        this.orthos,
        rowIndex,
        this.orthoCopyFields
      );
      return;
    }

    // Ctrl + Shift + V -> paste current row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      event.stopPropagation();

      if (!this.copiedOrthoRow) return;
      if (this.isRowDisabled(this.orthos, rowIndex)) return;

      this.applyRowValue(this.orthos, rowIndex, this.copiedOrthoRow);
      return;
    }
  }
// =========================
// history Section
// =========================
  onHistoryRowKeydown(event: KeyboardEvent, rowIndex: number): void {
    if (this.userIsSelectingTextInEditable(event)) return;

    const ctrlOrCmd = event.ctrlKey || event.metaKey;

    // Ctrl + D -> copy current column only from previous row
    if (ctrlOrCmd && !event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.historiesInput, rowIndex)) return;

      const controlName = this.getControlNameFromElement(event.target);
      if (!controlName) return;

      const previousRow = this.historiesInput.at(rowIndex - 1);
      const previousValue = previousRow.get(controlName)?.value;

      this.applySingleControlValue(this.historiesInput, rowIndex, controlName, previousValue);
      return;
    }

    // Ctrl + Shift + D -> copy full previous row
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      event.stopPropagation();

      if (rowIndex === 0) return;
      if (this.isRowDisabled(this.historiesInput, rowIndex)) return;

      const previousRowData = this.getRowValue(
        this.historiesInput,
        rowIndex - 1,
        this.historyCopyFields
      );

      this.applyRowValue(this.historiesInput, rowIndex, previousRowData);
      return;
    }

    // Ctrl + Shift + C
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'c') {
      event.preventDefault();
      event.stopPropagation();

      this.copiedHistoryRow = this.getRowValue(
        this.historiesInput,
        rowIndex,
        this.historyCopyFields
      );
      return;
    }

    // Ctrl + Shift + V
    if (ctrlOrCmd && event.shiftKey && event.key.toLowerCase() === 'v') {
      event.preventDefault();
      event.stopPropagation();

      if (!this.copiedHistoryRow) return;
      if (this.isRowDisabled(this.historiesInput, rowIndex)) return;

      this.applyRowValue(this.historiesInput, rowIndex, this.copiedHistoryRow);
      return;
    }
  }

  // Common Helper for COpy Paste shortcut
  private getControlNameFromElement(element: EventTarget | null): string | null {
    let el = element as HTMLElement | null;

    while (el) {
      const controlName = el.getAttribute?.('data-control');
      if (controlName) {
        return controlName;
      }
      el = el.parentElement;
    }

    return null;
  }

  private applySingleControlValue(
    formArray: FormArray,
    rowIndex: number,
    controlName: string,
    value: any
  ): void {
    const row = formArray.at(rowIndex);
    const control = row.get(controlName);

    if (!control) return;

    control.patchValue(value, { emitEvent: false });
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
  }

  // private updateLayout(raw: unknown) {
  //   const idStr = raw != null && typeof (raw as any).toString === 'function'
  //     ? (raw as any).toString()
  //     : String(raw);

  //   this.isVertical = idStr === '15' || idStr === '16' || idStr === '24' || idStr === '18'; // replace with 15 & 16 for prod 13 & 24 &18 &13
  // }

  // async initializeAllForms(): Promise<void> {
  //   // Create an array to track all initialization outcomes
  //   const results = [];

  //   // Execute each initialization method and track results
  //   results.push(await this.executePromise(this.onIns(), 'onIns'));
  //   results.push(await this.executePromise(this.initializeMaxDeductibleForm(), 'initializeMaxDeductibleForm'));
  //   results.push(await this.executePromise(this.initializeCoInsuranceForm(), 'initializeCoInsuranceForm'));
  //   results.push(await this.executePromise(this.initializeOrthoForm(), 'initializeOrthoForm'));
  //   results.push(await this.executePromise(this.initializeCoverageForm(), 'initializeCoverageForm'));
  //   results.push(await this.executePromise(this.initializeHistForm(), 'initializeHistForm'));

  //   // Log any failures for debugging
  //   const failures = results.filter(r => !r.success);
  //   if (failures.length > 0) {
  //     console.warn(`${failures.length} initialization methods failed:`,
  //       failures.map(f => f.method).join(', '));
  //   }

  //   // Always call onRegister, regardless of any failures
  //   this.onRegister();
  // }
  private loadLayoutPreference(): void {
  const savedLayout = localStorage.getItem(this.layoutPreferenceKey);

  // Default view will be tab view when no preference exists.
  this.isVertical = savedLayout === 'single-page';
  }

  onLayoutToggle(checked: boolean): void {
    if (this.isChangingLayout || checked === this.isVertical) {
      return;
    }

    this.isChangingLayout = true;
    this.cdr.detectChanges();

    // Give the browser one frame to display the loader
    // before Angular creates all single-page tables.
    requestAnimationFrame(() => {
      this.layoutChangeTimeout = setTimeout(() => {
        this.isVertical = checked;

        localStorage.setItem(
          this.layoutPreferenceKey,
          checked ? 'single-page' : 'tabs'
        );

        this.cdr.detectChanges();

        // Wait until the new view has been rendered.
        requestAnimationFrame(() => {
          this.refreshQuestionsView();

          this.isChangingLayout = false;
          this.cdr.detectChanges();
        });
      }, 120);
    });
  }

  /**
   * Reloads the questions for the exact selected domain, office, form type
   * and plan-creation context. Every change to Form Type or Domain uses
   * this same method, so only the newest response may update the six tabs.
   */
  async initializeAllForms(): Promise<void> {
    const requestId = ++this.domainRequestId;
    const requestedDomain = this.benefitDomain;
    const params = this.buildParams();

    this.isQuestionReloading = true;
    this.questionLoadError = null;
    this.noQuestionsForDomain = false;

    // Prevent Dental rows from remaining visible while Medical questions load,
    // or vice versa. Do not change patient registration fields.
    this.clearQuestionSections();
    this.cdr.markForCheck();

    try {
      const questions = await this.fetchQuestionsOnce(params);
      if (requestId !== this.domainRequestId || requestedDomain !== this.benefitDomain) {
        return;
      }

      this.noQuestionsForDomain = questions.length === 0;
      const results: { method: string; success: boolean; error?: any }[] = [];
      results.push(await this.executePromise(this.onInsFromQuestions(questions), 'onIns'));
      results.push(await this.executePromise(this.initializeMaxDeductibleFormFromQuestions(questions), 'initializeMaxDeductibleForm'));
      results.push(await this.executePromise(this.initializeCoInsuranceFormFromQuestions(questions), 'initializeCoInsuranceForm'));
      results.push(await this.executePromise(this.initializeOrthoFormFromQuestions(questions), 'initializeOrthoForm'));
      results.push(await this.executePromise(this.initializeCoverageFormFromQuestions(questions), 'initializeCoverageForm'));
      results.push(await this.executePromise(this.initializeHistFormFromQuestions(questions), 'initializeHistForm'));

      if (requestId !== this.domainRequestId) {
        return;
      }

      const failures = results.filter(item => !item.success);
      if (failures.length) {
        console.warn('Question section initialization failed:', failures.map(item => item.method).join(', '));
        this.questionLoadError = 'Some verification sections could not be initialized.';
      }

      this.refreshQuestionsView();

      // Keep the existing flow for loading saved plan/answer data only after
      // the new domain's question controls have been recreated.
      this.onRegister();
    } catch (error) {
      if (requestId !== this.domainRequestId) {
        return;
      }
      console.error('Unable to load ' + requestedDomain + ' questions:', error);
      this.questionLoadError = error?.error?.message || 'Failed to load ' + requestedDomain + ' questions. Please try changing the selection again.';
      this.refreshQuestionsView();
    } finally {
      if (requestId === this.domainRequestId) {
        this.isQuestionReloading = false;
        this.cdr.markForCheck();
      }
    }
  }

  private clearQuestionSections(): void {
    this.proceduresData = [];
    this.maxData = [];
    this.coinsuranceData = [];
    this.coveragesData = [];
    this.orthoData = [];
    this.historyData = [];
    this.insuranceVerifyForm.setControl('proceduresInput', this.fb.array([]));
    this.pInsuranceForm.setControl('maximumInput', this.fb.array([]));
    this.coinsuranceForm.setControl('coinsurances', this.fb.array([]));
    this.insuranceCoveragesForm.setControl('procedures', this.fb.array([]));
    this.orthoForm.setControl('orthos', this.fb.array([]));
    this.historyForm.setControl('historiesInput', this.fb.array([]));
  }

// Helper method to execute a promise and handle success/failure
  private async executePromise(promise: Promise<any>, methodName: string): Promise<{method: string, success: boolean, error?: any}> {
    try {
      await promise;
      return { method: methodName, success: true };
    } catch (error) {
      console.error(`Error in ${methodName}:`, error);
      return { method: methodName, success: false, error };
    }
  }

  private setupFormListeners(): void {

    const isQuestionDataReady = false;

    this.patientForm.controls.formType.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(async () => {
      this.proceduresData = [];
      this.maxData = [];
      this.coveragesData = [];
      this.coinsuranceData = [];
      this.orthoData = [];
      this.historyData = [];
      // Load new questions based on form type
      try {
        await this.initializeAllForms();
        // console.log('initializeAllForms completed');
         this.verifySectionsWithNoQuestions();
        // await this.onIns();

        if (this.patientForm.controls.networkType.value &&
          this.patientForm.controls.groupId.value) {
          // console.log('Calling onRegister');
          // await this.onRegister(); // only after both previous methods complete
        }
      } catch (error) {
        console.error('Error initializing forms or fetching insurance:', error);
      }
    });

    this.patientForm.controls.groupId.valueChanges
      .pipe(skip(3),debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        this.patientForm.controls.planName.reset(null);
      });


    // Use a single subscription for both network and plan type changes
    // with debounce to prevent multiple rapid calls
    merge(
      this.patientForm.controls.networkType.valueChanges,
      this.patientForm.controls.planType.valueChanges,
      this.patientForm.controls.groupId.valueChanges
      // this.patientForm.controls.formType.valueChanges
      // this.patientForm.controls.groupId.valueChanges
    ).pipe(
      debounceTime(300), // Wait for 300ms of inactivity before triggering
      distinctUntilChanged(), // Only trigger if the value actually changed
      // Filtering to avoid unnecessarily operations when form is being initialized
      filter(() => this.isPatientFormInitialized &&
        this.patientForm.controls.networkType.value &&
        this.patientForm.controls.groupId.value)
    ).subscribe(() => {
      // Clear form answers but keep questions
      this.clearAllFormAnswers();

      // this.clearMaxForm();
      // this.clearCoinsuranceForm();
      // this.clearCoveragesForm();
      // this.clearOrthoForm();
      // Reload answers with the new parameters

    });
  }

  // Consolidate all form clearing operations
  private clearAllFormAnswers(): void {
    this.clearMaxForm();
    this.clearCoinsuranceForm();
    this.clearCoveragesForm();
    this.clearOrthoForm();
    this.onRegister();
  }

  // Helper method to clear all max form fields
  // clearProcedureForm(): void {
  //   const proceduresArray = this.insuranceVerifyForm.get('procedureName') as FormArray;
  //
  //   if (proceduresArray) {
  //     proceduresArray.controls.forEach(control => {
  //       control.get('procedureName')?.reset(); // Only reset the 'procedureName' field
  //     });
  //   }
  // }
  private clearMaxForm(): void {
    this.maximumInput.controls.forEach((control) => {
      control.patchValue({
        maxInput: null,
        maxCoverage: null,
        maxPlan: null,
        maxService: null
      });
    });
  }
  // private clearMaxQForm(): void {
  //   const maxArray = this.pInsuranceForm.get('procedureName') as FormArray;
  //
  //   if (maxArray) {
  //     maxArray.controls.forEach(control => {
  //       control.get('maxName')?.reset(); // Only reset the 'procedureName' field
  //     });
  //   }
  // }
  private clearCoinsuranceForm(): void {
    this.coinsurances.controls.forEach((control) => {
      control.patchValue({
        percent: null
      });
    });
  }
  // private clearCoinsuranceQForm(): void {
  //   const coinsuranceArray = this.coinsuranceForm.get('coinsurance') as FormArray;
  //
  //   if (coinsuranceArray) {
  //     coinsuranceArray.controls.forEach(control => {
  //       control.get('coinsurance')?.reset(); // Only reset the 'coinsurance' field
  //     });
  //   }
  // }
  private clearCoveragesForm(): void {
    this.procedures.controls.forEach((control) => {
      control.patchValue({
        percentage: null,
        frequency: null,
        guidelines: null,
        // agehighvalue: null,
        agelowvalue: null
      });
    });
  }
  // private clearCoveragesQForm(): void {
  //   const coveragesArray = this.insuranceCoveragesForm.get('procedure') as FormArray;
  //
  //   if (coveragesArray) {
  //     coveragesArray.controls.forEach(control => {
  //       control.get('procedure')?.reset(); // Only reset the 'procedure' field
  //     });
  //   }
  // }
  private clearOrthoForm(): void{
    this.orthos.controls.forEach((control) => {
      control.patchValue({
        orthoPercent: null,
        orthoFrequency: null,
        orthoGuidelines: null,
        age: null
      });
    });
  }
  // clearOrthoQForm(): void{
  //   const orthoArray = this.orthoForm.get('ortho') as FormArray;
  //
  //   if (orthoArray) {
  //     orthoArray.controls.forEach(control => {
  //       control.get('ortho')?.reset(); // Only reset the 'ortho' field
  //     });
  //   }
  // }
  // clearHistoryForm(): void
  // {
  //   const histArray = this.historyForm.get('historyName') as FormArray;
  //
  //   if (histArray) {
  //     histArray.controls.forEach(control => {
  //       control.get('historyName')?.reset(); // Only reset the 'historyName' field
  //     });
  //   }
  // }


  private fetchVerificationData(): void {
  this.insuranceService
    .getVerifyProcedureData({ patientId: this.patientId, domain: this.benefitDomain })
    .pipe(first())
    .subscribe(
      (response: any) => {

        const verification =
          response?.eligibilityVerification ??
          (Array.isArray(response) ? response : []);

        this.verificationData = verification;

        this.handleVerificationStatus(verification);
      },
      (error: any) => {
        console.error('Error fetching verification data:', error);
      }
    );
}

  private registerAndLoadPatientData(): void {
    this.getPayer().then(() => {

      // Update form states
      this.updateFormStates();

      // Call onRegister only once after forms are initialized
      // this.onRegister();

      // Load patient details
      if (this.patientId) {
        this.loadPatientDetails().then(() => {
          this.loadProvidersByOfficeId(this.officeId);
          // Only call onRegister() once after patient details are loaded
          // and only if we have the required data
          // if (this.patientForm.controls.networkType.value &&
          //   this.patientForm.controls.groupId.value) {
          //   this.onRegister();
          // }
        });
      }
    });
  }

  async loadPatientDetails(): Promise<void>  {
    const reqData = {
      patientId: this.patientId,
      clientId: this.authService.clientId
    };
    const formatDateToYYYYMMDD = (dateString: string): Date | null => {
      if (!dateString) {
        return null;
      } // Handle null or undefined
      const [month, day, year] = dateString.split('-'); // Assuming MM-DD-YYYY format
      return new Date(Number(year), Number(month) - 1, Number(day), 12); // Rearrange to YYYY-MM-DD
    };

    const mapNetworkType = (apiValue: string | null): string => {
      if (!apiValue || apiValue.trim() === '') {
        return 'In-Network'; // Default to In-Network for null, undefined, or empty string
      }
      if (apiValue === 'In-Network' || apiValue === 'inNetwork') {
        return 'In-Network';
      } else if (apiValue === 'Out-Of-Network' || apiValue === 'outNetwork') {
        return 'Out-Of-Network';
      }
      return apiValue || 'In-Network'; // Default to In-Network
    };

    try {
      const response = await this.patientService.getPatientDetails(reqData).pipe(first()).toPromise();
      if (response) {
        this.getPatientFormData = response;
        const data = response;
        this.status = data.active;
        const patientPayer =
          data.primaryIns?.payer ||
          data.secondaryIns?.payer ||
          null;

        const insuranceProvider =
          patientPayer?.id ?? null;

        const insuranceProviderName =
          patientPayer?.name ||
          data.payerName ||
          null;

        /*
        * Prefer the payer from the payer API because it contains
        * the latest name/code.
        */
        const matchedPayer =
          this.payerArray.find(
            (payer: any) =>
              String(payer?.id) ===
              String(insuranceProvider)
          );

        this.selectedPayer =
          matchedPayer ||
          (
            insuranceProvider
              ? {
                  id: insuranceProvider,
                  name: insuranceProviderName,
                  payerIdCode:
                    patientPayer?.payerIdCode || null
                }
              : null
          );

        this.PayerId =
          this.selectedPayer?.payerIdCode ||
          patientPayer?.payerIdCode ||
          null;

        this.patientForm.patchValue({
          patientName: data.firstName || null,
          patientLastName: data.lastName || null,
          insuranceProvider,
          insuranceProviderName,
          memberId: data.memberId || null,
          officeId: data.officeId ? data.officeId : null,
          provider: data.providerName ? data.providerName : null,
          memberDob: formatDateToYYYYMMDD(data.subscriber?.dob) ? formatDateToYYYYMMDD(data.subscriber?.dob) : null,
          patientDob: formatDateToYYYYMMDD(data.dob) || null,
          employerName: data.primaryIns?.employerName ? data.primaryIns?.employerName : data.secondaryIns?.employerName ? data.secondaryIns?.employerName : null,
          groupId: data.primaryIns?.groupNo ? data.primaryIns?.groupNo : data.secondaryIns?.groupNo ? data.secondaryIns?.groupNo : null,
          insurancePhoneNumber: data.primaryIns?.contact?.phones?.[0]?.number ? data.primaryIns?.contact?.phones?.[0]?.number : data.secondaryIns?.contact?.phones?.[0]?.number ? data.secondaryIns?.contact?.phones?.[0]?.number : null,
          networkType: mapNetworkType(data.primaryIns?.networkType ? data.primaryIns?.networkType : data.secondaryIns?.networkType ? data.secondaryIns?.networkType : 'In-Network'),
          planCreation:
            data.primaryIns?.planCreation !== undefined && data.primaryIns?.planCreation !== null
              ? data.primaryIns.planCreation
              : data.secondaryIns?.planCreation !== undefined && data.secondaryIns?.planCreation !== null
              ? data.secondaryIns.planCreation
              : null,
          planType: data.primaryIns?.planType ? data.primaryIns?.planType : data.secondaryIns?.planType ? data.secondaryIns?.planType : 'PPO',
          formType: data.primaryIns?.formType ? data.primaryIns?.formType : data.secondaryIns?.formType ? data.secondaryIns?.formType : 'FULL FORM',
          remarks: data.remarks || null,
          notes : data.notes || null,
        });

        this.payerSearchControl.setValue(
          this.selectedPayer,
          {
            emitEvent: false
          }
        );

        this.filteredPayers =
          this.payerArray.slice(
            0,
            this.MAX_PAYER_RESULTS
          );
        // Open Medical-only patients in their available domain when no route
        // explicitly selected Dental or Medical.
        const hasExplicitDomain = this.activatedRoute.snapshot.queryParamMap.has('domain');
        const medicalOnly = data.patientBenefitType === 'MEDICAL' ||
          (!!data.medicalInsurance && !data.primaryIns && !data.secondaryIns);
        if (!hasExplicitDomain && medicalOnly && this.benefitDomain !== 'MEDICAL') {
          this.benefitDomain = 'MEDICAL';
          this.planSearchDomain = 'MEDICAL';
          this.verificationData = [];
          this.loadAuditChangeRequestsForDomain();
        }
        // Populate the active insurance before assembling office-question params.
        this.applyInsuranceForBenefitDomain();
        if (!hasExplicitDomain && medicalOnly) {
          this.initializeAllForms().then(() => this.fetchVerificationData());
        }
        this.cdr.markForCheck(); 
      } else {
        this.showError('Patient details not found!');
      }
      return Promise.resolve();
    } catch (error) {
      this.showError(error.error?.message || 'An error occurred while loading patient details.');
    }
  }

  loadOfficeData(){
    const params = {
      isOfficeNameAndId: true,
      clientId: this.authService.clientId
    };

    this.providerServices.getAllOffice(params).pipe(first()).subscribe(
      (response: any) => {
        if (response) {
          this.OfficeType = response;
        }
      });
  }


  trackByFn(index: number, item: any) {
    return item.id;
  }

  async getPayer(): Promise<void> {

    const paramsP = {
      isPayerNameAndId: true,
      clientId: this.authService?.clientId ?? null
    };

    try {

      this.payerSearchLoading = true;

      const response: any =
        await this.patientService
          .getPayer(paramsP)
          .pipe(first())
          .toPromise();

      this.payerArray = Array.isArray(response)
        ? response
        : [];

      /*
      * Sort once instead of sorting during every search.
      */
      this.payerArray.sort((a: any, b: any) =>
        String(a?.name || '').localeCompare(
          String(b?.name || '')
        )
      );

      /*
      * Do not render 1800+ mat-options initially.
      */
      this.filteredPayers =
        this.payerArray.slice(
          0,
          this.MAX_PAYER_RESULTS
        );

    } catch (error) {

      const err: any = error;

      this.payerArray = [];
      this.filteredPayers = [];

      this.showError(
        err?.error?.message ||
        'Failed to fetch payer list'
      );

    } finally {

      this.payerSearchLoading = false;

      this.cdr.markForCheck();
    }
  }

  private initializePayerSearch(): void {

  this.payerSearchControl.valueChanges
    .pipe(
      debounceTime(200),
      distinctUntilChanged()
    )
    .subscribe((value: any) => {

      /*
       * mat-autocomplete returns the complete payer object
       * when an option is selected.
       */
      if (value && typeof value === 'object') {
        return;
      }

      /*
       * If the user manually edits an already selected payer,
       * clear the underlying payer selection.
       *
       * Otherwise the screen could display "Delta Dental"
       * while insuranceProvider still contains the previous ID.
       */
      if (this.selectedPayer) {

        const enteredValue =
          String(value || '').trim();

        const selectedName =
          String(this.selectedPayer?.name || '').trim();

        if (enteredValue !== selectedName) {

          this.selectedPayer = null;
          this.PayerId = null;

          this.patientForm.patchValue(
            {
              insuranceProvider: null,
              insuranceProviderName: null
            },
            {
              emitEvent: false
            }
          );
        }
      }

      this.filterPayers(value || '');

      this.cdr.markForCheck();
    });
  }


  private filterPayers(searchValue: string): void {

    const search =
      String(searchValue || '')
        .trim()
        .toLowerCase();

    if (!search) {

      this.filteredPayers =
        this.payerArray.slice(
          0,
          this.MAX_PAYER_RESULTS
        );

      return;
    }

    this.filteredPayers =
      this.payerArray
        .filter((payer: any) => {

          const name =
            String(
              payer?.name || ''
            ).toLowerCase();

          const payerId =
            String(
              payer?.payerIdCode || ''
            ).toLowerCase();

          return (
            name.includes(search) ||
            payerId.includes(search)
          );
        })
        .slice(
          0,
          this.MAX_PAYER_RESULTS
        );
  }

  displayPayer = (payer: any): string => {
    return payer?.name || '';
  };

  onPayerSearchFocus(): void {

    if (!this.payerSearchControl.enabled) {
      return;
    }

    /*
    * Show only the first batch when opening
    * an empty autocomplete.
    */
    if (!this.payerSearchControl.value) {

      this.filteredPayers =
        this.payerArray.slice(
          0,
          this.MAX_PAYER_RESULTS
        );
    }
  }

  onPayerSelected(payer: any): void {

    if (!payer) {
      return;
    }

    this.selectedPayer = payer;

    /*
    * Database payer ID.
    */
    this.patientForm
      .get('insuranceProvider')
      ?.setValue(payer.id);

    /*
    * Payer display/name value currently sent as payerName.
    */
    this.patientForm
      .get('insuranceProviderName')
      ?.setValue(payer.name || null);

    /*
    * Payer ID code used by getClientDetails().
    *
    * Example:
    * payer.id        -> 123
    * payer.name      -> "Aetna"
    * payerIdCode     -> "60054"
    */
    this.PayerId =
      payer.payerIdCode || null;

    this.patientForm
      .get('insuranceProvider')
      ?.markAsDirty();

    this.patientForm
      .get('insuranceProvider')
      ?.markAsTouched();

    /*
    * Reset the autocomplete results after selection.
    */
    this.filteredPayers =
      this.payerArray.slice(
        0,
        this.MAX_PAYER_RESULTS
      );

    this.cdr.markForCheck();
  }

  showError(message: string) {
    swal.fire({
      title: 'Error!',
      icon: 'error',
      text: message,
      showConfirmButton: false,
      timer: 5000,
    });
  }

  onPlanTypeChange(selectedValue: string): void {


    this.notEligilbleSelected =
      selectedValue === 'NOT ELIGIBLE' ||
      selectedValue === 'ELIGIBLE' ||
      selectedValue === 'CNID' ||
      selectedValue === 'TPI' ||
      selectedValue === 'ELIG CHECK';

  }

  get filteredPlanTypes(): any[] {
  const formType = this.patientForm.get('formType')?.value;

  const eligCheckPlanTypes = [
    'ELIGIBLE',
    'NOT ELIGIBLE',
    'TPI',
    'CNID'
  ];

  if (formType === 'ELIG CHECK') {
    return this.pType.filter((plan: any) =>
      eligCheckPlanTypes.includes(plan.value)
    );
  }

  return this.pType.filter((plan: any) =>
    !eligCheckPlanTypes.includes(plan.value)
  );
  }

  // onFormTypeChange(selectedValue: string): void{
  //   this.shortFormSelected = selectedValue === 'SHORT FORM';
  //   }
  onFormTypeChange(value: string): void {
    this.planCreation = value;
    // console.log('Plancreation', this.planCreation);

    // Reset data
    this.proceduresData = [];
    this.maxData = [];
    this.coveragesData = [];
    this.coinsuranceData = [];
    this.orthoData = [];
    this.historyData = [];

    // Call API directly
    this.initializeAllForms().then(() => {
      // console.log('initializeAllForms completed');

      if (this.patientForm.controls.networkType.value &&
        this.patientForm.controls.groupId.value) {
        // console.log('Calling onRegister');
        // this.onRegister();
        }
      }).catch ((error) => {
        console.error('Error initializing forms or fetching insurance:', error);
    });
  }

  onOfficeTypeChange(value: string): void {
    this.officeId = value;
    // console.log('officeId', this.officeId);
    // reset provider dropdown
    this.providerType = [];
    this.patientForm.patchValue({ provider: null });

    // Reset data
    this.proceduresData = [];
    this.maxData = [];
    this.coveragesData = [];
    this.coinsuranceData = [];
    this.orthoData = [];
    this.historyData = [];

    // call provider API based on officeId
    this.loadProvidersByOfficeId(value);

    // Call API directly
    this.initializeAllForms().then(() => {
      // console.log('initializeAllForms completed');

      if (this.patientForm.controls.networkType.value &&
        this.patientForm.controls.groupId.value) {
        // console.log('Calling onRegister');
        // this.onRegister();
      }
    }).catch ((error) => {
      console.error('Error initializing forms or fetching insurance:', error);
    });
  }

  openProviderModal(): void {
    if (!this.patientForm.get('officeId')?.value) {
      return;
    }

    const dialogRef = this.dialog.open(ProviderListModalComponent, {
      width: '950px',
      maxHeight: '80vh',
      data: {
        providers: this.providerType,
        selectedProviderId: this.patientForm.get('provider')?.value
      }
    });

    dialogRef.afterClosed().subscribe((selectedProvider: any) => {
      if (selectedProvider) {
        this.selectedProviderObj = selectedProvider;
        this.patientForm.patchValue({
          provider: selectedProvider.providerId
        });
      }
    });
  }

  loadProvidersByOfficeId(officeId: string): void {
    if (!officeId) {
      this.providerType = [];
      return;
    }

    const params = {
      providerOfficeId: officeId
    };

    this.providerServices.getProvidersByOfficeId(params).pipe(first()).subscribe(
      (response: any) => {
        this.providerType = response || [];

        const selectedProviderId = this.patientForm.get('provider')?.value;
        if (selectedProviderId) {
          this.selectedProviderObj =
            this.providerType.find((p: any) => p.providerId === selectedProviderId) || null;
        }
      },
      (error) => {
        console.error('Error loading providers:', error);
        this.providerType = [];
        this.selectedProviderObj = null;
      }
    );
  }


  clearPayerSelection(): void {

    this.selectedPayer = null;

    this.PayerId = null;

    this.patientForm.patchValue(
      {
        insuranceProvider: null,
        insuranceProviderName: null
      },
      {
        emitEvent: false
      }
    );

    this.patientForm
      .get('insuranceProvider')
      ?.markAsDirty();

    this.patientForm
      .get('insuranceProvider')
      ?.markAsTouched();

    this.payerSearchControl.setValue(
      '',
      {
        emitEvent: false
      }
    );

    this.filteredPayers =
      this.payerArray.slice(
        0,
        this.MAX_PAYER_RESULTS
      );

    this.cdr.markForCheck();
  }
  private enforcePayerIdLock(): void {
    this.proceduresInput.controls.forEach((group, idx) => {
      const ctrl = (group as FormGroup).get('procedureInput');
      if (this.isPayerId(this.proceduresData?.[idx]?.name)) {
        ctrl?.disable({ emitEvent: false });
      }
    });
  }
  private shouldAutoCompleteVerification(): boolean {
  const formType = this.patientForm.controls.formType.value;
  const planType = this.patientForm.controls.planType.value;

  return (
    // formType === 'ELIG CHECK' ||
    planType === 'CNID' ||
    planType === 'TPI'
    // planType === 'NOT ELIGIBLE' ||
    // planType === 'ELIGIBLE'
  );
  }
  private submitAutoCompletedVerification(): Promise<void> {
  return new Promise((resolve) => {
    const groupNo = this.patientForm.controls.groupId.value;

    const eligibilityVerification = [
      {
        patientId: this.patientId,
        groupNo,
        eligibilityEnum: 'PATIENT_INFO',
        verificationStatus: 'VERIFIED'
      },
      {
        patientId: this.patientId,
        groupNo,
        eligibilityEnum: 'HISTORY',
        verificationStatus: 'VERIFIED'
      },
      {
        patientId: this.patientId,
        groupNo,
        eligibilityEnum: 'ORTHO',
        verificationStatus: 'VERIFIED'
      },
      {
        patientId: this.patientId,
        groupNo,
        eligibilityEnum: 'COVERAGE_FREQUENCY',
        verificationStatus: 'VERIFIED'
      },
      {
        patientId: this.patientId,
        groupNo,
        eligibilityEnum: 'CO_INSURANCE',
        verificationStatus: 'VERIFIED'
      },
      {
        patientId: this.patientId,
        groupNo,
        eligibilityEnum: 'MAX_DEDUCTIBLES',
        verificationStatus: 'VERIFIED'
      }
    ];

    this.stopVerificationTimerOnly();

    const payload = {
      patientId: this.patientId,
      formFillTime: this.getCurrentTimerSeconds(),
      eligibilityVerification
    };

    this.insuranceService
      .updateVerifyProcedureData(payload)
      .pipe(first())
      .subscribe(
        (resp: any) => {
          this.verificationData =
            resp?.eligibilityVerification ??
            (Array.isArray(resp) ? resp : []);

          this.handleVerificationStatus(this.verificationData);
          this.refreshVerificationView();

          resolve();
        },
        (error: any) => {
          console.error('Auto verification API failed:', error);
          resolve();
        }
      );
  });
}
  onUpdatePatientInfo() {
    // Run your update logic for patient info
    // Once update is successful or clicked, enable the insurance form
    this.verificationFormEditable = true;

    this.maximumInput.controls.forEach(ctrl => {
      ctrl.get('maxCoverage')?.disable();
      ctrl.get('maxPlan')?.disable();
      ctrl.get('maxService')?.disable();
    });

    const cid = String(this.authService.clientId ?? '');
    this.waitingPeriodEnabled = ['26', '34'].includes(cid);
    // Apply to every row control
    this.coinsurances.controls.forEach(ctrl => {
      const wp = ctrl.get('waitingPeriod');
      if (!wp) { return; }
      if (this.waitingPeriodEnabled) {
        wp.enable({ emitEvent: false });
      } else {
        wp.disable({ emitEvent: false });
        // Optional: clear the value for non-26 clients
        // wp.reset(null, { emitEvent: false });
      }
    });
    this.enforcePayerIdLock();
    /*this.coinsurances.controls.forEach(ctrl => {
      ctrl.get('waitingPeriod')?.disable();
    });*/
  //   if (this.shouldAutoCompleteVerification()) {
  //   this.submitAutoCompletedVerification();
  //   return;
  // }

  }

  HiddenColoumn(){
    const rid = Number(this.authService.clientId);

  // Deductible: show only for RID 43 and 34
  const deductibleAllowedRids = [43, 34];

  if (deductibleAllowedRids.includes(rid)) {
    if (!this.coinsuranceColumns.includes('deductible')) {
      this.coinsuranceColumns = [
        ...this.coinsuranceColumns,
        'deductible'
      ];
    }
  } else {
    this.coinsuranceColumns = this.coinsuranceColumns.filter(
      c => c !== 'deductible'
    );
  }

  // Waiting Period: show only for RID 26
  const waitingPeriodAllowedRids = [26, 34];

  if (waitingPeriodAllowedRids.includes(rid)) {
    if (!this.coinsuranceColumns.includes('waitingPeriod')) {
      this.coinsuranceColumns = [
        ...this.coinsuranceColumns,
        'waitingPeriod'
      ];
    }
  } else {
    this.coinsuranceColumns = this.coinsuranceColumns.filter(
      c => c !== 'waitingPeriod'
    );
  }

  //ageLimit Ortho: show onlyfor RDG
  const ageAllowedRids = [34];

  if (ageAllowedRids.includes(rid)) {
    if (!this.orthoColumns.includes('age')) {
      this.orthoColumns = [
        ...this.orthoColumns,
        'age'
      ];
    }
  } else {
    this.orthoColumns = this.orthoColumns.filter(
      c => c !== 'age'
    );
  }

  //Eligibiity history: show onlyfor RDG
  const histEligibility = [3,6,9,13,14,18,21,23,27,32,34,40,42];

  if (histEligibility.includes(rid)) {
    if (!this.historyColumns.includes('historyEligibility')) {
      this.historyColumns = [
        ...this.historyColumns,
        'historyEligibility'
      ];
    }
  } else {
    this.historyColumns = this.historyColumns.filter(
      c => c !== 'historyEligibility'
    );
  }

    //Max  Coverage,plan, service: show onlyfor RDG
    const maxded = [90];

    const maxFields = [
      'maxService',
      'maxCoverage',
      'maxPlan'
    ];

    if (maxded.includes(rid)) {

      this.maxColumns = [
        ...this.maxColumns,
        ...maxFields.filter(field => !this.maxColumns.includes(field))
      ];

    } else {

      this.maxColumns = this.maxColumns.filter(
        field => !maxFields.includes(field)
      );
    }
  }

  private onInsFromQuestions(all: Question[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      const filtered = all.filter(q => this.questionMatchesCategory(q, 'PATIENT INFO'));

      if (filtered.length > 0) {
        this.proceduresData = filtered.map(item => ({
          id: item.id,
          name: item.question,
          question: item.question,
          controlName: item.question.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '')
        }));

        this.insuranceVerifyForm = this.fb.group({
          proceduresInput: this.fb.array(
            this.proceduresData.map(() => this.fb.group({ procedureInput: [null] }))
          )
        });
      } else {
        this.proceduresData = [];
        this.insuranceVerifyForm = this.fb.group({ proceduresInput: this.fb.array([]) });
      }

      resolve();
    } catch (err) {
      reject(err);
    }
  });
}

  private initializeMaxDeductibleFormFromQuestions(all: Question[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      const items = all.filter(q => this.questionMatchesCategory(q, 'MAX & DEDUCTIBLE'));

      if (items.length > 0) {
        this.maxData = items.map(item => ({
          id: item.id,
          name: item.question,
          controlName: item.question.replace(/\s+/g, ' ').toUpperCase()
        }));

        this.pInsuranceForm = this.fb.group({
          maximumInput: this.fb.array(
            this.maxData.map(() =>
              this.fb.group({
                maxInput: [null],
                maxCoverage: [null],
                maxPlan: [null],
                maxService: [null],
              })
            )
          )
        });
      } else {
        this.maxData = [];
        this.pInsuranceForm = this.fb.group({ maximumInput: this.fb.array([]) });
      }

      resolve();
    } catch (err) {
      reject(err);
    }
  });
}

private initializeCoInsuranceFormFromQuestions(all: Question[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      const items = all.filter(q => this.questionMatchesCategory(q, 'CO-INSURANCE'));

      this.coinsuranceData = items.map(item => ({
        id: item.id,
        serviceName: item.question,
        controlName: item.question.replace(/\s+/g, ' ').toUpperCase()
      }));

      const formArray = this.fb.array(
        this.coinsuranceData.map(item =>
          this.fb.group({
            serviceName: [item.serviceName || null],
            percent: [{ value: null, disabled: !this.isEditable }],
            waitingPeriod: [{ value: 'N/A', disabled: !this.isEditable }],
            deductible: [{ value: null, disabled: !this.isEditable }]
          })
        )
      );

      this.coinsuranceForm.setControl('coinsurances', formArray);

      resolve();
    } catch (err) {
      reject(err);
    }
  });
}

private initializeCoverageFormFromQuestions(all: Question[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      const items = all.filter(
        q => this.questionMatchesCategory(q, 'COVERAGE & FREQUENCY')
      );

      this.coveragesData = items.map(item => ({
        id: item.id,
        serviceName: item.question,
        controlName: item.question.replace(/\s+/g, ' ').toUpperCase(),
        percent: item.percent,
        limitation: item.limitation,
        disclaimers: item.disclaimers,
        age: item.age
      }));

      const formArray = this.fb.array(
        this.coveragesData.map(item =>
          this.fb.group({
            procedure: [item.serviceName || null],
            percentage: [item.percent || null],
            frequency: [item.limitation || null],
            guidelines: [item.disclaimers || null],
            agelowvalue: [item.age || null]
          })
        )
      );

      this.insuranceCoveragesForm.setControl(
        'procedures',
        formArray
      );

      resolve();
    } catch (err) {
      reject(err);
    }
  });
}

  private initializeOrthoFormFromQuestions(all: Question[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      const items = all.filter(q => this.questionMatchesCategory(q, 'ORTHO'));

      this.orthoData = items.map(item => ({
        id: item.id,
        serviceName: item.question,
        controlName: item.question.replace(/\s+/g, '_').toUpperCase()
      }));

      const formArray = this.fb.array(
        this.orthoData.map(item =>
          this.fb.group({
            ortho: [item.serviceName || null],
            orthoPercent: [{ value: null, disabled: !this.isEditable }],
            orthoFrequency: [{ value: null, disabled: !this.isEditable }],
            orthoGuidelines: [{ value: null, disabled: !this.isEditable }],
            age: [{ value: null, disabled: !this.isEditable }],
          })
        )
      );

      this.orthoForm.setControl('orthos', formArray);
      resolve();
    } catch (err) {
      reject(err);
    }
  });
}
private initializeHistFormFromQuestions(all: Question[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    try {
      const items = all.filter(q => this.questionMatchesCategory(q, 'HISTORY'));

      this.historyData = items.map(item => ({
        id: item.id,
        serviceName: item.question,
        controlName: item.question.replace(/\s+/g, '_').toUpperCase()
      }));

      const formArray = this.fb.array(
        this.historyData.map(item =>
          this.fb.group({
            historyName: [item.serviceName || null],
            historyInput: [{
              value: 'No History',
              disabled: !this.isEditable
            }],
            historyEligibility: [{
              value: null,
              disabled: !this.isEditable
            }]
          })
        )
      );

      this.historyForm.setControl(
        'historiesInput',
        formArray
      );

      resolve();
    } catch (err) {
      reject(err);
    }
  });
}

  private buildParams(): { domain: BenefitDomain; officeId: any; formType: string; planCreation: string } {
    const officeId = this.officeId || this.patientForm.get('officeId')?.value || this.getPatientFormData?.officeId;
    const formType = this.patientForm.get('formType')?.value || 'FULL FORM';
    const planCreation = this.planCreation ?? this.patientForm.get('planCreation')?.value;

    return {
      domain: this.benefitDomain,
      officeId,
      formType,
      // The existing API accepts null and resolves it to NO. Keep the literal
      // "null" in the URL when no plan-creation value has been selected.
      planCreation: planCreation == null ? 'null' : String(planCreation)
    };
  }

  private async fetchQuestionsOnce(params: ReturnType<UserworkareaComponent['buildParams']>): Promise<Question[]> {
    const response = await this.insuranceService.getInsuranceQuentions(params).pipe(first()).toPromise();
    if (!Array.isArray(response)) {
      throw new Error('Unexpected office-question API response');
    }
    // Extra guard: never display records explicitly tagged for another domain.
    return response.filter(question =>
      !question?.benefitDomain ||
      String(question.benefitDomain).toUpperCase() === params.domain
    );
  }

  private questionMatchesCategory(question: Question, category: string): boolean {
    return String(question?.category || '').trim().replace(/\s+/g, ' ').toUpperCase() === category;
  }

  startResize(event: MouseEvent, columnName: string) {
    this.resizingColumn = this.elRef.nativeElement.querySelector(`th.mat-header-cell.mat-column-${columnName}`);
    this.startX = event.pageX;
    this.startWidth = this.resizingColumn.offsetWidth;

    this.renderer.listen('window', 'mousemove', this.onResize.bind(this));
    this.renderer.listen('window', 'mouseup', this.endResize.bind(this));
  }

  onResize(event: MouseEvent) {
    const width = this.startWidth + (event.pageX - this.startX);
    this.resizingColumn.style.width = `${width}px`;
  }

  endResize() {
    this.resizingColumn = null;
  }

  onFocus(index: number): void {
    this.isFocused[index] = true; // Set focus state to true when textarea is focused
  }

  onBlur(index: number): void {
    this.isFocused[index] = false; // Reset focus state when textarea loses focus
  }

  get proceduresInput(): FormArray {
    return this.insuranceVerifyForm.get('proceduresInput') as FormArray;
  }

  get procedures(): FormArray {
    return this.insuranceCoveragesForm.get('procedures') as FormArray;
  }

  get orthos(): FormArray {
    return this.orthoForm.get('orthos') as FormArray;
  }

  get coinsurances(): FormArray {
    return this.coinsuranceForm.get('coinsurances') as FormArray;
  }

  get maximumInput(): FormArray {
    return this.pInsuranceForm.get('maximumInput') as FormArray;
  }

  get historiesInput(): FormArray {
    return this.historyForm.get('historiesInput') as FormArray;
  }

  // Change status
  changeStatus(status: any) {
    // tslint:disable-next-line:triple-equals
    if (status == true) {
      this.status = false;
    } else {
      this.status = true;
    }
  }

  /*fetchGroupIds() {
    // Simulating API Call (Replace this with actual API service call)
    setTimeout(() => {
      this.groupIds = ['12345', '67890', 'ABCDE', 'FGHIJ']; // Replace with API response
    }, 1000);
  }*/

  searchGroup(): void {
    this.groupSearchSubscription?.unsubscribe();
    this.groupSearchLoading = false;
    const query = (this.groupSearchText || '').trim();

    this.searchedOnce = true;
    this.groupResults = [];
    this.groupSearchErrorMsg = null;

    this.cdr.detectChanges();

    if (!query) {
      return;
    }

    const params: any = {
      groupNumber: query
    };

  this.callGroupSearchApi(params);
  }

  /**
   * Use the matching insurance for the active verification and audit domain.
   * A patient may have both Dental and Medical benefits with different plans.
   */
  private applyInsuranceForBenefitDomain(): void {
    const patient = this.getPatientFormData;
    if (!patient) { return; }
    const insurance = this.benefitDomain === 'MEDICAL'
      ? patient.medicalInsurance
      : (patient.primaryIns || patient.secondaryIns);
    const payer = insurance?.payer || null;
    const payerId = payer?.id ?? null;
    const matchingPayer = this.payerArray.find((item: any) =>
      payerId !== null && String(item?.id) === String(payerId));
    this.selectedPayer = matchingPayer || (payerId !== null
      ? { id: payerId, name: payer?.name || null, payerIdCode: payer?.payerIdCode || null }
      : null);
    this.PayerId = matchingPayer?.payerIdCode || payer?.payerIdCode || null;
    this.planCreation = insurance?.planCreation ?? null;
    this.officeId = patient.officeId || this.officeId;
    this.patientForm.patchValue({
      insuranceProvider: payerId,
      insuranceProviderName: payer?.name ?? null,
      employerName: insurance?.employerName ?? null,
      groupId: insurance?.groupNo ?? null,
      planName: insurance?.planName ?? null,
      planType: insurance?.planType ?? 'PPO',
      formType: insurance?.formType ?? 'SHORT FORM',
      planCreation: this.planCreation,
      networkType: insurance?.networkType ?? 'In-Network',
      insurancePhoneNumber: insurance?.contact?.phones?.[0]?.number ?? null
    }, { emitEvent: false });
    this.payerSearchControl.setValue(this.selectedPayer, { emitEvent: false });
  }

  changeBenefitDomain(domain: BenefitDomain): void {
    if (domain === this.benefitDomain) { return; }
    // Only question/answer edits need confirmation. Patient metadata is kept
    // when switching between the verification question domains.
    if (this.insuranceVerifyForm.dirty || this.pInsuranceForm.dirty || this.coinsuranceForm.dirty ||
        this.insuranceCoveragesForm.dirty || this.orthoForm.dirty || this.historyForm.dirty) {
      swal.fire({
        title: 'Switch question domain?',
        text: 'Unsaved verification answers may be discarded. Save your work first.',
        icon: 'warning', showCancelButton: true, confirmButtonText: 'Switch domain'
      }).then(result => { if (result.isConfirmed) { this.applyBenefitDomain(domain); } });
      return;
    }
    this.applyBenefitDomain(domain);
  }

  private applyBenefitDomain(domain: BenefitDomain): void {
    this.benefitDomain = domain;
    this.planSearchDomain = domain;
    this.auditSubmissionSent = false;
    this.auditSubmissionInProgress = null;
    this.verificationData = [];
    this.applyInsuranceForBenefitDomain();
    this.loadAuditChangeRequestsForDomain();
    this.groupSearchSubscription?.unsubscribe();
    this.planLookupSubscription?.unsubscribe();
    this.groupResults = [];
    this.groupSearchLoading = false;
    this.searchedOnce = false;
    this.groupSearchErrorMsg = null;
    this.closeGroupSearch();
    this.selectedPlanScope = 'CLIENT';
    this.route.navigate([], {
      relativeTo: this.activatedRoute, queryParams: { domain },
      queryParamsHandling: 'merge', replaceUrl: true
    });
    this.initializeAllForms().then(() => {
      this.fetchVerificationData();
      this.cdr.markForCheck();
    }).catch(error => {
      console.error('Failed to load domain questions', error);
      this.cdr.markForCheck();
    });
  }

  private loadAuditChangeRequestsForDomain(): void {
    const clientId = Number(this.authService.getClientId());
    const patientId = Number(this.patientId);
    const domain = this.benefitDomain;
    const request = ++this.auditChangeRequestVersion;
    this.activeAuditChangeRequest = null;
    if (!clientId || !patientId) { return; }
    this.auditChangeRequestLoading = true;
    this.insuranceService.getAuditChangeRequestsForPatient(patientId, clientId, domain)
      .pipe(first()).subscribe((response: any) => {
        if (request !== this.auditChangeRequestVersion || domain !== this.benefitDomain) { return; }
        this.activeAuditChangeRequest = response?.status === 'CHANGES_REQUESTED' ? response : null;
        this.auditChangeRequestLoading = false;
        this.cdr.markForCheck();
      }, (error: any) => {
        if (request !== this.auditChangeRequestVersion || domain !== this.benefitDomain) { return; }
        this.activeAuditChangeRequest = null;
        this.auditChangeRequestLoading = false;
        if (error?.status !== 404) {
          console.warn('Unable to load domain-specific audit change requests', error);
        }
        this.cdr.markForCheck();
      });
  }

  changePlanSearchDomain(domain: BenefitDomain): void {
    if (domain === this.planSearchDomain) { return; }
    this.planSearchDomain = domain;
    this.groupSearchSubscription?.unsubscribe();
    this.groupResults = [];
    this.searchedOnce = false;
    this.groupSearchErrorMsg = null;
    if (this.groupSearchText?.trim()) { this.searchGroup(); }
    this.cdr.markForCheck();
  }

  get selectedGroupScope(): PlanSearchScope {
    return this.selectedPlanScope;
  }

  setGroupSearchScope(scope: PlanSearchScope): void {
    if (this.groupSearchScope === scope) return;
    this.groupSearchScope = scope;
    this.groupSearchSubscription?.unsubscribe();
    this.groupSearchLoading = false;
    this.groupResults = [];
    this.searchedOnce = false;
    this.groupSearchErrorMsg = null;

    if ((this.groupSearchText || '').trim()) {
      this.searchGroup();
    }
    this.cdr.markForCheck();
  }

  onGroupIdInput(): void {
    // A manually entered group starts a new lookup in the current client.
    this.selectedPlanScope = 'CLIENT';
  }

  showGroupSearchPanel(): void {
  if (this.viewMode === 'patient') {
    return;
  }

  if (!this.showGroupSearch) {
    this.groupSearchScope = 'CLIENT';
    this.groupSearchText =
      this.patientForm.get('groupId')?.value || '';

    this.groupResults = [];
    this.searchedOnce = false;
    this.groupSearchErrorMsg = null;
  }

    this.showGroupSearch = true;
    this.cdr.markForCheck();
  }


  closeGroupSearch(): void {
    this.groupSearchSubscription?.unsubscribe();
    this.groupSearchLoading = false;
    this.showGroupSearch = false;
    this.groupResults = [];
    this.searchedOnce = false;
    this.groupSearchErrorMsg = null;

    this.cdr.markForCheck();
  }

  private callGroupSearchApi(params: any): void {
    this.groupSearchLoading = true;
    const lookupDomain = this.planSearchDomain;
  this.groupSearchSubscription = this.insuranceService
      .getGroupSearch(params, this.authService.clientId, this.groupSearchScope, this.planSearchDomain)
      .pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (lookupDomain !== this.planSearchDomain) { return; }
          this.groupSearchLoading = false;
          this.groupResults = Array.isArray(response) ? response : [];
          this.groupSearchErrorMsg = this.groupResults.length ? null : 'No results found';

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.groupSearchLoading = false;
          const apiErrors = error?.error?.errors;

          this.groupSearchErrorMsg =
            Array.isArray(apiErrors) && apiErrors.length
              ? apiErrors[0]
              : (error?.error?.message || 'No results found');

          this.groupResults = [];

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
        });
      }
    );
  }

  selectGroupId(groupNumber: string, planName: string): void {
  // The selected plan's domain must agree with the verification domain.
  // Do not silently switch active forms while selecting a plan.
  if (this.benefitDomain !== this.planSearchDomain) {
    swal.fire({
      icon: 'info', title: 'Switch verification domain',
      text: 'Switch the verification domain to ' + this.planSearchDomain +
        ' before applying this plan, so existing answers are not mixed.'
    });
    return;
  }
  this.selectedPlanScope = this.groupSearchScope;

  // Set BOTH values without firing valueChanges
  this.patientForm.patchValue(
    {
      groupId: groupNumber,
      planName: planName
    },
    {
      emitEvent: false
    }
  );

  // Mark selected values as user changes
  this.patientForm.get('groupId')?.markAsDirty();
  this.patientForm.get('groupId')?.markAsTouched();

  this.patientForm.get('planName')?.markAsDirty();
  this.patientForm.get('planName')?.markAsTouched();

  // Close inline search
  this.closeGroupSearch();

  // IMPORTANT:
  // valueChanges does NOT run.
  // Explicitly call API once AFTER group + plan are both populated.
  this.onRegister();
}

  openGroupIdModal(): void {
  this.groupSearchSubscription?.unsubscribe();
  this.groupSearchScope = 'CLIENT';
  this.groupSearchLoading = false;
  // Get value from main reactive form
  const groupId = this.patientForm.get('groupId')?.value;

  // Patch into modal search input
  this.groupSearchText = groupId || '';

  // Reset results state
  this.groupResults = [];
  this.groupSearchErrorMsg = '';
  this.searchedOnce = false;

  // Focus input AFTER modal renders
  setTimeout(() => {
    this.modalSearchBox?.nativeElement.focus();
  }, 200);
}

  onRegister(): void {
  this.planLookupSubscription?.unsubscribe();
  // Clear previous plan/network feedback until its new answers are returned.
  [this.proceduresData, this.maxData, this.coinsuranceData,
   this.coveragesData, this.orthoData, this.historyData].forEach(
    rows => rows.forEach((row: any) => this.setQuestionAuditFeedback(row, null))
  );
  this.clearMaxForm();
  this.clearCoinsuranceForm();
  this.clearCoveragesForm();
  this.clearOrthoForm();

  const clientId = this.authService.clientId;
  const formType = this.patientForm.controls.formType.value;
  const networkType = this.patientForm.controls.networkType.value;
  const groupNumber = this.patientForm.controls.groupId.value;

  const reqData: any = {
    clientId,
    domain: this.benefitDomain,
    officeId: this.officeId,
    patientId: this.patientId,
    formType,
    planCreation: this.planCreation,
    groupNumber: groupNumber,
    network: networkType,
    payerId: this.PayerId,
    planName:this.patientForm.controls.planName.value
  };

  const planType = this.patientForm.controls?.planType?.value;
  if (planType) reqData.planType = planType;

  // ✅ SINGLE API CALL for deductible + coInsurance + ortho
  const lookupDomain = this.benefitDomain;
  this.planLookupSubscription = this.insuranceService
    .getClientDetails(reqData,{}, this.selectedPlanScope).pipe(first()).subscribe(
    (resp: any) => {
      if (lookupDomain !== this.benefitDomain) { return; }
      const deductible = resp?.deductible ?? [];
      const coinsurance = resp?.coinsurance ?? [];
      const ortho = resp?.ortho ?? [];

      const planName = resp?.planName ?? null;
      if (planName) {
        this.patientForm.get('planName')?.setValue(planName);
        // optional: prevent it from being marked dirty if you want
        this.patientForm.get('planName')?.markAsPristine();
      }



      // Patch each section
      this.patchMaxFromDeductible(deductible);
      this.patchCoveragesFromCoinsurance(coinsurance);
      this.patchCoinsuranceFromCoInsurance(coinsurance, networkType);
      this.patchOrthoFromOrtho(ortho);
      this.refreshQuestionsView();

      // Mark init flags (like your current code)
      this.isMaxFormInitialized = true;
      this.isCoverageFormInitialized = true;
      this.isCoFormInitialized = true;
      this.isOrthoFormInitialized = true;
    },
    (error) => {
      console.error('Error fetching combined API:', error);

    this.isMaxFormInitialized = true;
    this.isCoverageFormInitialized = true;
    this.isCoFormInitialized = true;
    this.isOrthoFormInitialized = true;

    this.refreshQuestionsView();

      swal.fire({
        title: 'Error!',
        icon: 'error',
        text: error.error?.message || 'An error occurred while fetching data.',
        showConfirmButton: false,
        timer: 5000
      });
    }
  );

  this.loadPatientDetailsOnce(); // ✅ replaces loadAppointmentInfo + loadHistory
}

  private patchMaxFromDeductible(deductible: any[]): void {
    this.maxData.forEach((row: any) => this.setQuestionAuditFeedback(row, null));
    this.dataExists = Array.isArray(deductible) && deductible.length > 0;

    if (!this.dataExists) {
      console.warn('No data found in Max (deductible).');
      return;
    }

    this.maxData.forEach((question: any, index: number) => {
      const matchingItem = deductible.find(
        (item: any) =>
          (item.planInfo ?? '').toUpperCase() === (question.name ?? '').toUpperCase()
      );

      this.setQuestionAuditFeedback(question, matchingItem);
      if (matchingItem) {
        this.maximumInput.at(index).patchValue({
          maxInput: matchingItem.amount ?? null,
          maxCoverage: matchingItem.coverageLevel ?? null,
          maxPlan: matchingItem.planPeriod ?? null,
          maxService: matchingItem.serviceType ?? null
        });
      }
    });
  }

  private patchCoveragesFromCoinsurance(coinsurance: any[]): void {
    const filteredData = (coinsurance ?? []).filter((x: any) => x?.serviceName);
    const normalize = (value: any) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const selectedNetwork = normalize(this.patientForm?.controls?.networkType?.value);
    this.coveragesData.forEach((row: any) => {
      const answer = filteredData.find((item: any) =>
        normalize(item.serviceName) === normalize(row.serviceName) &&
        (!item.network || !selectedNetwork || normalize(item.network) === selectedNetwork)
      );
      this.setQuestionAuditFeedback(row, answer);
    });
    this.coverageExists = filteredData.length > 0;

    if (!this.coverageExists) {
      console.warn('No matching data found for coverages.');
      return;
    }

    const proceduresArray = this.insuranceCoveragesForm.get('procedures') as FormArray;

    filteredData.forEach((procedure: any) => {
      const matchingControl = proceduresArray.controls.find(
        (control) => control.get('procedure')?.value === procedure.serviceName
      );

      if (matchingControl) {
        matchingControl.patchValue({
          percentage: procedure.percent ?? null,
          frequency: procedure.limitation ?? null,
          guidelines: procedure.disclaimers ?? null,
          agelowvalue: procedure.age ?? null
        });
      }
    });
  }

  private patchCoinsuranceFromCoInsurance(coinsurance: any[], networkType: string): void {
    const filtered = (coinsurance ?? []).filter((x: any) => x?.serviceName);

    this.coinsuranceExists = filtered.some(
      (x: any) => (x?.percent ?? '').toString().trim() !== ''
    );

    if (!filtered.length) {
      console.warn('No coinsurance data found.');
      return;
    }

    const hasNetwork = filtered.some((x: any) => x?.network);
    const dataForNetwork = hasNetwork ? filtered.filter((x: any) => x.network === networkType) : filtered;

    const updatedCoinsuranceArray = this.coinsuranceData.map((question: any) => {
      const matchingItem = dataForNetwork.find(
        (item: any) =>
          (item.serviceName ?? '').toUpperCase() === (question.serviceName ?? '').toUpperCase()
      );

      this.setQuestionAuditFeedback(question, matchingItem);
      return this.fb.group({
        serviceName: [question.serviceName || null],
        percent: [{
          value: matchingItem?.percent ?? null,
          disabled: !this.isEditable
        }],
        waitingPeriod: [{
          value: matchingItem?.waitingPeriod ?? 'N/A',
          disabled: !this.isEditable
        }],
        deductible: [{
          value: matchingItem?.deductibleApplies ?? null,
          disabled: !this.isEditable
        }],
      });
    });

    this.coinsuranceForm.setControl('coinsurances', this.fb.array(updatedCoinsuranceArray));
  }

  private patchOrthoFromOrtho(ortho: any[]): void {
    const filteredData = (ortho ?? []).filter((x: any) => x?.serviceName);
    this.orthoExists = filteredData.length > 0;

    if (!this.orthoExists) {
      console.warn('No ortho data found.');
      return;
    }

    const updatedFormArray = this.fb.array(
      this.orthoData.map((question: any) => {
        const matchingData = filteredData.find(
          (item: any) => item.serviceName === question.serviceName
        );

        this.setQuestionAuditFeedback(question, matchingData);
        return this.fb.group({
          ortho: [question.serviceName || null],
          orthoPercent: [{
            value: matchingData?.percent ?? null,
            disabled: !this.isEditable
          }],
          orthoFrequency: [{
            value: matchingData?.limitation ?? null,
            disabled: !this.isEditable
          }],
          orthoGuidelines: [{
            value: matchingData?.disclaimers ?? null,
            disabled: !this.isEditable
          }],
          age: [{
            value: matchingData?.age ?? null,
            disabled: !this.isEditable
          }]
        });
      })
    );

    this.orthoForm.setControl('orthos', updatedFormArray);
  }
  private loadPatientDetailsOnce(): void {
  const formType = this.patientForm.controls.formType.value;

  const reqData: any = {
    formType,
    patientId: this.patientId,
    clientId: this.authService.clientId,
    planCreation: this.planCreation,
    officeId: this.officeId,
  };

  this.patientService.getAllPatients(reqData).pipe(first()).subscribe(
    (response: any) => {
      const additionalInfo = response?.additionalInfo ?? [];
      const history = response?.history ?? [];

      // ✅ patch Appointment Info from additionalInfo
      this.patchAppointmentInfo(additionalInfo);

      // ✅ patch History from history
      this.patchHistory(history);
      this.refreshQuestionsView();

      this.isPatientFormInitialized = true;
      this.isHistoryFormInitialized = true;
    },
    (error) => {
      console.error('Error fetching patient details:', error);
    }
  );
  }
  private patchAppointmentInfo(additionalInfo: any[]): void {
  this.proceduresData.forEach((row: any) => this.setQuestionAuditFeedback(row, null));
  this.InsuranceExists = additionalInfo.length > 0;

  if (!additionalInfo.length) {
    console.warn('No additionalInfo returned.');
    return;
  }

  additionalInfo.forEach((item: any) => {
    const matchedProcedure = this.proceduresData.find(procedure =>
      procedure.question?.trim().toUpperCase() === item.serviceType?.trim().toUpperCase()
    );

    if (matchedProcedure) {
      this.setQuestionAuditFeedback(matchedProcedure, item);
      const procedureIndex = this.proceduresData.indexOf(matchedProcedure);
      const formArray = this.insuranceVerifyForm.get('proceduresInput') as FormArray;

      if (procedureIndex >= 0 && formArray.at(procedureIndex)) {
        formArray.at(procedureIndex).patchValue({
          procedureInput: item.response
        });
      } else {
        console.warn('Invalid procedureIndex or FormControl not found for question:', item.serviceType);
      }
    } else {
      console.warn('No matching procedure found for question:', item.serviceType);
    }
  });

  // console.log('Appointment Info values updated successfully');
  }
  private patchHistory(history: any[]): void {
  const filteredData = history ?? [];

  if (!filteredData.length) {
    this.historyExists = false;
    console.warn('No history returned.');
    return;
  }

  this.historyExists = true;

  const updatedHistoryData = this.historyData.map((question: any) => {
    const matchingData = filteredData.find(
      (item: any) => item.serviceName?.toUpperCase() === question.serviceName?.toUpperCase()
    );

    const row = {
      ...question,
      response: matchingData ? matchingData.response : 'No History',
      eligible: matchingData ? matchingData.eligible : null
    };
    this.setQuestionAuditFeedback(row, matchingData);
    return row;
  });
  this.historyData = updatedHistoryData;

  const historyArray = this.fb.array(
    updatedHistoryData.map((item: any) =>
      this.fb.group({
        historyName: [item.serviceName || null],
        historyInput: [{
          value: item.response || 'No History',
          disabled: !this.isEditable
        }],
        historyEligibility: [{
          value: item.eligible,
          disabled: !this.isEditable
        }]
      })
    )
  );

  this.historyForm.setControl('historiesInput', historyArray);

  // console.log('History values updated successfully');
  }

  updateFormStates(): void {
    if (!this.isEditable) {
      this.patientForm.disable(); // Disables the entire form
      this.payerSearchControl.disable({
        emitEvent: false
      });
      // Enable only the remarks field
      this.patientForm.get('remarks')?.enable();
      this.insuranceVerifyForm.disable();
      this.proceduresInput.controls.forEach(control => control.disable());
      this.pInsuranceForm.disable();
      this.maximumInput.controls.forEach(control => control.disable());
      this.maximumInput.controls.forEach((control: AbstractControl) => {
        if (control instanceof FormGroup) {
          control.get('maxService')?.disable();
          control.get('maxPlan')?.disable();
          control.get('maxCoverage')?.disable();
        }
      });
      this.coinsuranceForm.disable();
      this.coinsurances.controls.forEach((control: AbstractControl) => {
        if (control instanceof FormGroup) {
          // control.get('coverageLevel')?.disable();
          control.get('percent')?.disable();
          control.get('waitingPeriod')?.disable();
          control.get('deductible')?.disable();
          // control.get('message')?.disable();
        }
      });

      // this.insuranceCoveragesForm.disable();
      this.procedures.controls.forEach((group: AbstractControl) => {
        const formGroup = group as FormGroup;
        [ 'agelowvalue', 'guidelines', 'percentage', 'frequency', 'history'].forEach(field => {
          if (formGroup.get(field)) {
            formGroup.get(field)?.disable();
          }
        });
      });
      this.orthoForm.disable(); // Disables the entire form
      this.orthos.controls.forEach(control => {
        if (control instanceof FormGroup) {
          Object.keys(control.controls).forEach(key => {
            control.get(key)?.disable();
          });
        }
      });
      this.historyForm.disable();
      this.historiesInput.controls.forEach((control: AbstractControl) => {
        if (control instanceof FormGroup) {
          // Disable both historyName and historyInput controls
          control.get('historyName')?.disable();
          control.get('historyInput')?.disable();
          control.get('historyEligibility')?.disable();
        }
      });

    } else {
      this.patientForm.enable(); // Enables the entire form
      if (this.viewMode !== 'patient') {

        this.payerSearchControl.enable({
          emitEvent: false
        });

      } else {

        this.payerSearchControl.disable({
          emitEvent: false
        });
      }
      this.patientForm.controls.planName.disable();
      this.patientForm.get('remarks')?.disable();
      this.insuranceVerifyForm.enable();
      this.proceduresInput.controls.forEach(control => control.enable());
      this.pInsuranceForm.enable();
      this.maximumInput.controls.forEach(control => control.enable());
      this.maximumInput.controls.forEach((control: AbstractControl) => {
        if (control instanceof FormGroup) {
          control.get('maxService')?.disable();
          control.get('maxPlan')?.disable();
          control.get('maxCoverage')?.disable();
        }
      });
      this.coinsuranceForm.enable();
      this.coinsurances.controls.forEach((control: AbstractControl) => {
        if (control instanceof FormGroup) {
          // control.get('coverageLevel')?.enable();
          control.get('percent')?.enable();
          control.get('waitingPeriod')?.enable();
          control.get('deductible')?.enable();
          // control.get('message')?.enable();
        }
      });

      this.insuranceCoveragesForm.enable();
      this.orthoForm.enable();
      this.historyForm.enable();
    }
  }

  private verifySectionsWithNoQuestions(): void {

  const sections: {
    hasQuestions: boolean;
    eligibilityEnum: EligibilityEnum;
    resultKey: VerificationResultKey;
    flag:
      | 'allFieldsFilled'
      | 'allMaxFieldsFilled'
      | 'allCoFieldsFilled'
      | 'allCoverageFieldsFilled'
      | 'allOrthoFieldsFilled'
      | 'allHistFieldsFilled';
  }[] = [
    {
      hasQuestions: this.proceduresData.length > 0,
      eligibilityEnum: 'PATIENT_INFO',
      resultKey: 'Appointment',
      flag: 'allFieldsFilled'
    },
    {
      hasQuestions: this.maxData.length > 0,
      eligibilityEnum: 'MAX_DEDUCTIBLES',
      resultKey: 'MaxDeductible',
      flag: 'allMaxFieldsFilled'
    },
    {
      hasQuestions: this.coinsuranceData.length > 0,
      eligibilityEnum: 'CO_INSURANCE',
      resultKey: 'CoInsurance',
      flag: 'allCoFieldsFilled'
    },
    {
      hasQuestions: this.coveragesData.length > 0,
      eligibilityEnum: 'COVERAGE_FREQUENCY',
      resultKey: 'Coverage',
      flag: 'allCoverageFieldsFilled'
    },
    {
      hasQuestions: this.orthoData.length > 0,
      eligibilityEnum: 'ORTHO',
      resultKey: 'Ortho',
      flag: 'allOrthoFieldsFilled'
    },
    {
      hasQuestions: this.historyData.length > 0,
      eligibilityEnum: 'HISTORY',
      resultKey: 'History',
      flag: 'allHistFieldsFilled'
    }
  ];

  sections.forEach(section => {

    // Section actually has questions.
    // Normal verification logic handles it.
    if (section.hasQuestions) {
      return;
    }

    // console.log(
    //   `[Verification] No questions for ${section.eligibilityEnum}, auto verifying`
    // );

    // Update UI immediately
    this[section.flag] = true;
    this.verificationResults[section.resultKey] = 'VERIFIED';

    const existing = this.verificationData.find(
      (x: any) => x.eligibilityEnum === section.eligibilityEnum
    );

    // Only hit API if backend isn't already VERIFIED
    if (existing?.verificationStatus !== 'VERIFIED') {
      this.upsertVerificationStatus(
        section.eligibilityEnum,
        'VERIFIED',
        section.resultKey
      );
    }
  });

  this.refreshVerificationView();
}

  handleVerificationStatus(data: any): void {
    const formEligibilityMap = {
      PATIENT_INFO: 'allFieldsFilled',
      MAX_DEDUCTIBLES: 'allMaxFieldsFilled',
      CO_INSURANCE: 'allCoFieldsFilled',
      COVERAGE_FREQUENCY: 'allCoverageFieldsFilled',
      ORTHO: 'allOrthoFieldsFilled',
      HISTORY: 'allHistFieldsFilled',
    };

    // Initialize all fields to false
    Object.keys(formEligibilityMap).forEach(key => {
      this[formEligibilityMap[key]] = false;
    });

    // Update the fields based on the fetched data
    data.forEach((item: any) => {
      const fieldKey = formEligibilityMap[item.eligibilityEnum];

      if (fieldKey) {
        this[fieldKey] = item.verificationStatus === 'VERIFIED';

      }
    });
     this.refreshVerificationView();
  }

  private upsertVerificationStatus(
  eligibilityEnum: string,
  verificationStatus: 'VERIFIED' | 'PENDING' | 'ERROR',
  resultKey: VerificationResultKey
): void {
  const groupNo = this.patientForm.controls.groupId.value;

  const existing = this.verificationData?.find((x: any) => x.eligibilityEnum === eligibilityEnum);

  const requestData = {
    patientId: this.patientId,
    groupNo,
    eligibilityEnum,
    verificationStatus
  };

  const headers = existing?.id ? { id: existing.id } : {};

  // ✅ single merged endpoint (same method name, regardless of enum)
  this.insuranceService.updateVerifyProcedureData(requestData, headers)
    .pipe(first())
    .subscribe(
      (resp: any) => {
        this.notify({
          title: 'Verification Updated!',
          text: `Status set to ${verificationStatus}.`,
          icon: 'success',
          showConfirmButton: false,
          timer: 5000
        });

        // keep UI status per section
        this.verificationResults[resultKey] = verificationStatus;

        // ✅ keep local cache in sync so next time it becomes "update" automatically
        if (!existing && resp?.id) {
          this.verificationData = [...(this.verificationData ?? []), resp];
        } else if (existing) {
          existing.verificationStatus = verificationStatus;
        }
      },
      (error: any) => {
        console.error('Verification upsert failed:', error);
        this.notify({
          title: 'Error!',
          text: 'Failed to update verification status.',
          icon: 'error',
          showConfirmButton: false,
          timer: 3000
        });

        this.verificationResults[resultKey] = 'ERROR' as any;
      }
    );
  }
  private readonly verificationLabelMap: Record<string, string> = {
  PATIENT_INFO: 'Appointment / Patient Info',
  MAX_DEDUCTIBLES: 'Max / Deductibles',
  CO_INSURANCE: 'Co-Insurance',
  COVERAGE_FREQUENCY: 'Coverage / Frequency',
  ORTHO: 'Ortho',
  HISTORY: 'History'
};

private formatStatus(status: string): string {
  // normalize anything unexpected
  if (status === 'VERIFIED') return '✅ VERIFIED';
  if (status === 'PENDING') return '⏳ PENDING';
  if (status === 'NOT_VERIFIED') return '❌ NOT VERIFIED';
  return status;
}
private buildVerificationSummaryHtml(
  resp: any[],
  auditResult?: 'not-ready' | 'success' | 'already-submitted' | 'failed'
): string {
  const rows = (resp ?? []).map((x: any) => {
    const label = this.verificationLabelMap[x.eligibilityEnum] ?? x.eligibilityEnum;
    const statusText = this.formatStatus(x.verificationStatus);

    return `<div style="display:flex;justify-content:space-between;gap:12px;">
              <span>${label}</span>
              <b>${statusText}</b>
            </div>`;
  });

  const verifiedCount = (resp ?? []).filter((x: any) => x.verificationStatus === 'VERIFIED').length;
  const total = (resp ?? []).length;

  let auditMessage = '';
  if (auditResult === 'success' || auditResult === 'already-submitted' || this.auditSubmissionSent) {
    auditMessage = `
      <div style="margin-top:14px;padding:10px 12px;border-radius:8px;background:#e9f8ee;color:#237a3b;font-weight:600;">
        ✅ Patient sent to Audit successfully.
      </div>

      <div class="verification-breakdown-download">
        <div class="verification-breakdown-title">
          Would you like to download the breakdown form?
        </div>
        <div class="verification-breakdown-subtitle">
          Choose the format you want to download.
        </div>
        <div class="verification-breakdown-actions">
          <button
            type="button"
            class="verification-breakdown-btn verification-breakdown-excel"
            data-breakdown-format="excel">
            <i class="fa-solid fa-file-excel"></i>
            Excel
          </button>

          <button
            type="button"
            class="verification-breakdown-btn verification-breakdown-pdf"
            data-breakdown-format="pdf">
            <i class="fa-solid fa-file-pdf"></i>
            PDF
          </button>
        </div>
      </div>`;
  } else if (auditResult === 'failed') {
    auditMessage = `
      <div style="margin-top:14px;padding:10px 12px;border-radius:8px;background:#fdecec;color:#b42335;font-weight:600;">
        ⚠ Verification is complete, but the patient could not be sent to Audit.
      </div>`;
  }

  return `
    <div style="text-align:left;">
      <div style="margin-bottom:10px;"><b>${verifiedCount}/${total}</b> sections verified</div>
      ${rows.join('')}
      ${auditMessage}
    </div>
  `;
}

  private buildAuditSubmissionPayload(): any {
    const patient = this.getPatientFormData ?? {};
    const primaryInsurance = patient.primaryIns;
    const hasPrimaryInsurance =
      primaryInsurance !== null &&
      primaryInsurance !== undefined &&
      typeof primaryInsurance === 'object' &&
      Object.keys(primaryInsurance).length > 0;

    return {
      clientId: this.authService.getClientId(),
      patientId: Number(this.patientId),
      insuranceSelection: this.benefitDomain === 'MEDICAL' ? 'PRIMARY' : (hasPrimaryInsurance ? 'PRIMARY' : 'SECONDARY'),
      priority: String(patient.urgency || '').toUpperCase() === 'URGENT' ? 'HIGH' : 'MEDIUM',
      benefitDomain: this.benefitDomain
    };
  }

  private submitAuditWhenFullVerificationComplete(
    verificationData: any[]
  ): Promise<'not-ready' | 'success' | 'already-submitted' | 'failed'> {
    const fullVerification = (verificationData ?? []).find(
      (item: any) => item?.eligibilityEnum === 'FULL_VERIFICATION'
    );

    if (fullVerification?.verificationStatus !== 'VERIFIED') {
      return Promise.resolve('not-ready');
    }

    if (this.auditSubmissionSent) {
      return Promise.resolve('already-submitted');
    }

    if (this.auditSubmissionInProgress) {
      return this.auditSubmissionInProgress;
    }

    const payload = this.buildAuditSubmissionPayload();
    const submissionDomain = this.benefitDomain;

    this.auditSubmissionInProgress = this.insuranceService
      .submitAuditSubmission(payload)
      .pipe(first())
      .toPromise()
      .then(() => {
        if (submissionDomain === this.benefitDomain) { this.auditSubmissionSent = true; }
        return 'success' as const;
      })
      .catch((error: any) => {
        if (error?.status === 409) {
          if (submissionDomain === this.benefitDomain) { this.auditSubmissionSent = true; }
          return 'already-submitted' as const;
        }

        console.error('Audit submission failed:', error);
        return 'failed' as const;
      })
      .finally(() => {
        this.auditSubmissionInProgress = null;
      });

    return this.auditSubmissionInProgress;
  }

  private buildVerificationPayload(): any {
  const groupNo = this.patientForm.controls.groupId.value;

  const patientInfo: VerificationStatus =
    this.proceduresInput.controls.every(c => this.isFilled(c.get('procedureInput')?.value))
      ? 'VERIFIED'
      : 'PENDING';

  const maxDeductibles: VerificationStatus =
    this.maximumInput.controls.every(c => this.isFilled(c.get('maxInput')?.value))
      ? 'VERIFIED'
      : 'PENDING';

  const coInsurance: VerificationStatus =
    this.coinsurances.controls.every(c => this.isFilled(c.get('percent')?.value))
      ? 'VERIFIED'
      : 'PENDING';

  const coverageFreq: VerificationStatus =
    this.procedures.controls.every(c =>
      this.isFilled(c.get('percentage')?.value) &&
      this.isFilled(c.get('frequency')?.value)
    )
      ? 'VERIFIED'
      : 'PENDING';

  const ortho: VerificationStatus =
    this.orthos.controls.every(c =>
      this.isFilled(c.get('orthoPercent')?.value) &&
      this.isFilled(c.get('orthoFrequency')?.value)
    )
      ? 'VERIFIED'
      : 'PENDING';

  const history: VerificationStatus =
    this.historiesInput.controls.every(c => this.isFilled(c.get('historyInput')?.value))
      ? 'VERIFIED'
      : 'PENDING';

  const eligibilityVerification = [
    { patientId: this.patientId, groupNo, eligibilityEnum: 'PATIENT_INFO', verificationStatus: patientInfo },
    { patientId: this.patientId, groupNo, eligibilityEnum: 'MAX_DEDUCTIBLES', verificationStatus: maxDeductibles },
    { patientId: this.patientId, groupNo, eligibilityEnum: 'CO_INSURANCE', verificationStatus: coInsurance },
    { patientId: this.patientId, groupNo, eligibilityEnum: 'COVERAGE_FREQUENCY', verificationStatus: coverageFreq },
    { patientId: this.patientId, groupNo, eligibilityEnum: 'ORTHO', verificationStatus: ortho },
    { patientId: this.patientId, groupNo, eligibilityEnum: 'HISTORY', verificationStatus: history }
  ];

  const allVerified = eligibilityVerification.every(x => x.verificationStatus === 'VERIFIED');

  if (allVerified) {
    this.stopVerificationTimerOnly();
  }

  return {
    patientId: this.patientId,
    formFillTime: allVerified ? this.getCurrentTimerSeconds() : null,
    eligibilityVerification
  };
}
  private isFilled(value: any): boolean {
  return value !== null && value !== undefined && String(value).trim() !== '';
  }
  submitAllVerificationStatuses(showPopup: boolean = true): Promise<void> {
  return new Promise((resolve) => {
    const groupNo = this.patientForm.controls.groupId.value;
    if (!groupNo) return resolve();

    const payload = this.buildVerificationPayload();

    this.insuranceService.updateVerifyProcedureData(payload)
  .pipe(first())
  .subscribe(
    async (resp: any) => {
      this.ngZone.run(() => {
        this.verificationData = resp?.eligibilityVerification ?? resp ?? [];
        this.handleVerificationStatus(this.verificationData);
        this.refreshVerificationView();
      });

      const auditResult = await this.submitAuditWhenFullVerificationComplete(
        this.verificationData
      );

      if (showPopup) {
        swal.fire({
          title: 'Verification Status',
          icon: auditResult === 'failed' ? 'warning' : 'info',
          html: this.buildVerificationSummaryHtml(this.verificationData, auditResult),
          showConfirmButton: true,
          didOpen: () => {
            const popup = swal.getPopup();
            if (!popup) {
              return;
            }

            popup
              .querySelectorAll<HTMLButtonElement>('[data-breakdown-format]')
              .forEach((button: HTMLButtonElement) => {
                button.addEventListener('click', () => {
                  const format = button.dataset.breakdownFormat as 'excel' | 'pdf';
                  if (format === 'excel' || format === 'pdf') {
                    this.downloadForm(format);
                  }
                });
              });
          }
        }).then(() => resolve());
      } else {
        resolve();
      }
    },
    (error) => {
      console.error('Verification status API failed:', error);
      resolve();
    }
  );
  });
  }
  private refreshVerificationView(): void {
    this.ngZone.run(() => {
      this.cdr.markForCheck();
      this.cdr.detectChanges();
    });
  }

  checkInsuranceAllFieldsStatus(): void {
  
     this.allFieldsFilled = this.proceduresInput.controls.every(c => {
    const v = c.get('procedureInput')?.value;
    return v && v.trim() !== '';
  });

  const status = this.allFieldsFilled ? 'VERIFIED' : 'PENDING';
  this.upsertVerificationStatus('PATIENT_INFO', status, 'Appointment');
  }

  checkMaxAllFieldsStatus(): void {

     this.allMaxFieldsFilled = this.maximumInput.controls.every(c => {
    const v = c.get('maxInput')?.value;
    return v && v.trim() !== '';
  });

  const status = this.allMaxFieldsFilled ? 'VERIFIED' : 'PENDING';
  this.upsertVerificationStatus('MAX_DEDUCTIBLES', status, 'MaxDeductible');
  }

  checkCoInsAllFieldsStatus(): void {
 
     this.allCoFieldsFilled = this.coinsurances.controls.every(c => {
    const percent = c.get('percent')?.value;
    return percent && percent.trim() !== '';
  });

  const status = this.allCoFieldsFilled ? 'VERIFIED' : 'PENDING';
  this.upsertVerificationStatus('CO_INSURANCE', status, 'CoInsurance');
  }

  checkCoverageInsAllFieldsStatus(): void {

     this.allCoverageFieldsFilled = this.procedures.controls.every(c => {
    const percentage = c.get('percentage')?.value;
    const frequency = c.get('frequency')?.value;
    return percentage && percentage.trim() !== '' && frequency && frequency.trim() !== '';
  });

  const status = this.allCoverageFieldsFilled ? 'VERIFIED' : 'PENDING';
  this.upsertVerificationStatus('COVERAGE_FREQUENCY', status, 'Coverage');
  }

  checkOrthoAllFieldsStatus(): void {
     this.allOrthoFieldsFilled = this.orthos.controls.every(c => {
    const percent = c.get('orthoPercent')?.value;
    const frequency = c.get('orthoFrequency')?.value;
    return percent && percent.trim() !== '' && frequency && frequency.trim() !== '';
  });

  const status = this.allOrthoFieldsFilled ? 'VERIFIED' : 'PENDING';
  this.upsertVerificationStatus('ORTHO', status, 'Ortho');
  }

  checkHistAllFieldsStatus(): void {
     this.allHistFieldsFilled = this.historiesInput.controls.every(c => {
    const v = c.get('historyInput')?.value;
    return v && v.trim() !== '';
  });

  const status = this.allHistFieldsFilled ? 'VERIFIED' : 'PENDING';
  this.upsertVerificationStatus('HISTORY', status, 'History');
  }

  downloadForm(format: 'excel' | 'pdf'): void {
    if (!this.patientId) {
      swal.fire({
        icon: 'warning',
        title: 'Patient Not Available',
        text: 'Patient information is required before the form can be downloaded.'
      });
      return;
    }

    const params = {
      patientId: this.patientId,
      format,
      clientId: this.authService.getClientId()
    };

    this.insuranceService.getExportFile(null, params).subscribe(
      (response: any) => {
        try {
          if (!response?.body) {
            throw new Error('Empty file received');
          }

          const contentDisposition = response.headers?.get('Content-Disposition') || '';
          const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
          const extension = format === 'pdf' ? 'pdf' : 'xlsx';
          const fallbackName = `patient-${this.patientId}.${extension}`;
          const fileName = match ? decodeURIComponent(match[1] || match[2]) : fallbackName;
          const contentType =
            response.headers?.get('Content-Type') ||
            (format === 'pdf'
              ? 'application/pdf'
              : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

          const blob = new Blob([response.body], { type: contentType });
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');

          link.href = downloadUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(downloadUrl);

          swal.fire({
            icon: 'success',
            title: 'Download Successful',
            text: `The file "${fileName}" has been downloaded successfully.`,
            showConfirmButton: false,
            timer: 2500
          });
        } catch (error) {
          swal.fire({
            icon: 'error',
            title: 'Download Failed',
            text: 'An unexpected error occurred while processing the file.'
          });
        }
      },
      (error: any) => {
        swal.fire({
          icon: 'error',
          title: 'Download Failed',
          text: error?.error?.message || error?.message || 'Unable to download the form. Please try again later.'
        });
      }
    );
  }

  async onVerticalSave(): Promise<void> {
    // reset flags
    Object.keys(this.sectionResults).forEach(k => this.sectionResults[k] = null);
    Object.keys(this.verificationResults).forEach(k => this.verificationResults[k] = null);

    // kick off all submits (they set sectionResults.* = 'success' | 'error' in vertical mode)
    // this.onSubmitCoinsurance();     // Execute first API
    // this.onSubmitCoverage();        // Execute second API
    // this.onSubmitOrtho();
    this.onSubmitCombinedDental();
    // console.log('called coinsurance, coverage & ortho');
    try {
      await this.onSubmitInsurance();       // Execute fourth API
      // console.log('called Appointment Info');
      // await this.onSubmitMaxDeductible();   // Execute fifth API
      // console.log('called max Ded');
      await this.onSubmitHistory();         // Execute sixth API
      // console.log('called Hist');
    } catch (error) {
      console.error('Error during API calls:', error);
    }

    // wait for requests to respond, then show the SAVE summary
    setTimeout(() => {
      const success = Object.entries(this.sectionResults).filter(([_, v]) => v === 'success').map(([k]) => k);
      const error   = Object.entries(this.sectionResults).filter(([_, v]) => v === 'error').map(([k]) => k);

      let html = '';
      if (success.length) { html += `<div>✅ Success: ${success.join(', ')}</div>`; }
      if (error.length) {   html += `<div>❌ Failed: ${error.join(', ')}</div>`; }

      // auto-close, then chain verification summary
      swal.fire({
        title: error.length ? 'Saved with Issues' : 'All Sections Saved',
        html,
        icon: error.length ? 'warning' : 'success',
        showConfirmButton: false,
        timer: 3000,
      }).then(() => {
        // give your verification calls a tiny buffer if they run after saves
        setTimeout(() => this.showVerificationSummary(true), 300);
      });
    }, 3000);
  }

// timed = true makes this also auto-close (no OK button)
  showVerificationSummary(timed = false): void {
    const verified = Object.entries(this.verificationResults).filter(([_, v]) => v === 'VERIFIED').map(([k]) => k);
    const pending  = Object.entries(this.verificationResults).filter(([_, v]) => v === 'PENDING').map(([k]) => k);
    const errors   = Object.entries(this.verificationResults).filter(([_, v]) => v === 'ERROR').map(([k]) => k);

    let html = '';
    if (verified.length) { html += `<div>✅ Verified: ${verified.join(', ')}</div>`; }
    if (pending.length) {  html += `<div>⏳ Pending: ${pending.join(', ')}</div>`; }
    if (errors.length) {   html += `<div>❌ Error: ${errors.join(', ')}</div>`; }

    // swal.fire({
    //   title: errors.length ? 'Verification Issues' : 'Verification Summary',
    //   html,
    //   icon: errors.length ? 'warning' : 'success',
    //   showConfirmButton: !timed,
    //   ...(timed ? { timer: 3000 } : {})
    // });
  }

  async onallSave(): Promise<void> {
  Object.keys(this.sectionResults).forEach(k => this.sectionResults[k] = null);
  Object.keys(this.verificationResults).forEach(k => this.verificationResults[k] = null);

  await this.onSubmitCombinedDental();
  await this.onSubmitInsurance();   // (you should also remove swal inside OR add silent flag similarly)
  await this.onSubmitHistory();     // (same idea)

  // update toggle immediately before popup
  await this.submitAllVerificationStatuses(false);

  this.refreshVerificationView();

  const success = Object.entries(this.sectionResults).filter(([_, v]) => v === 'success').map(([k]) => k);
  const error   = Object.entries(this.sectionResults).filter(([_, v]) => v === 'error').map(([k]) => k);

  let html = '';
  if (success.length) html += `<div>✅ Success: ${success.join(', ')}</div>`;
  if (error.length)   html += `<div>❌ Failed: ${error.join(', ')}</div>`;

  await swal.fire({
    title: error.length ? 'Saved with Issues' : 'All Sections Saved',
    html,
    icon: error.length ? 'warning' : 'success',
    showConfirmButton: true
  });

  // ✅ Now (and only now) update verification + show verification summary
  if (error.length === 0) {
  await this.submitAllVerificationStatuses();
  }
}

  async onSubmitPatientAndEnableVerification(): Promise<void> {
    const result = await this.onSubmitPatient();

    if (result === 'success') {
      this.onUpdatePatientInfo();
    } else {
      this.verificationFormEditable = false;
    }
  }

  onSubmitPatient(silent: boolean = false): Promise<'success' | 'error'> {
  return new Promise((resolve) => {
    if (!this.patientForm.valid) {
      if (!silent) {
        swal.fire({
          title: 'Invalid Form!',
          icon: 'warning',
          text: 'Please fill out all required fields correctly.',
          showConfirmButton: true
        });
      }
      return resolve('error');
    }

    const reqData: iProvider = {
      firstName: this.patientForm.controls.patientName.value || null,
      lastName: this.patientForm.controls.patientLastName.value || null,
      patientDob: this.patientForm.controls.patientDob.value
        ? this.datePipe.transform(this.patientForm.controls.patientDob.value, 'MM-dd-yyyy')
        : null,
      memberId: this.patientForm.controls.memberId.value || null,
      carrierName: this.patientForm.controls.insuranceProvider.value || null,
      payerName: this.patientForm.controls.insuranceProviderName.value || null,
      officeId: this.patientForm.controls.officeId.value || null,
      providerName: this.patientForm.controls.provider.value || null,
      memberDob: this.patientForm.controls.memberDob.value
        ? this.datePipe.transform(this.patientForm.controls.memberDob.value, 'MM-dd-yyyy')
        : null,
      groupNumber: this.patientForm.controls.groupId.value || null,
      insurancePhoneNumber: this.patientForm.controls.insurancePhoneNumber.value || null,
      formType: this.patientForm.controls.formType.value || null,
      planType: this.patientForm.controls.planType.value || null,
      employerName: this.patientForm.controls.employerName.value || null,
      planName: this.patientForm.controls.planName.value || null,
      planCreation: this.patientForm.controls.planCreation.value ?? null,
      networkType: this.patientForm.controls.networkType.value || null,
      remarks: this.patientForm.controls.remarks.value || null,
      notes: this.patientForm.controls.notes.value || null,
    };

    if (this.patientId) {
      const params = { patientId: this.patientId };

      this.insuranceService.updateUserWorkAreaPatient(reqData, params).pipe(first()).subscribe(
        (response: any) => {
          // Patient's NEW planType/formType is now saved.
          if (this.shouldAutoCompleteVerification()) {
            this.submitAutoCompletedVerification();
          }

          if (response && !silent) {
            swal.fire({
              icon: 'success',
              text: `Patient "${reqData.firstName}" updated successfully.`,
              showConfirmButton: false,
              timer: 3000
            });
          }
          resolve('success');
          // this.verificationFormEditable = true;
        },
        (error) => {
          if (!silent) {
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: error.error?.message || 'An error occurred while updating patient data.',
              showConfirmButton: false,
              timer: 5000
            });
          }
          resolve('error');
          // this.verificationFormEditable = false;
        }
      );
    } else {
      resolve('error');
    }
  });
  }

  private buildCommonParams() {
  const network = this.patientForm.controls.networkType.value;
  const groupNumber = this.patientForm.controls.groupId.value;
  const planType = this.patientForm.controls.planType.value;
  const formType = this.patientForm.controls.formType.value;
  const patientId = this.patientId;
  const planName = this.patientForm.controls.planName.value;

  if (!groupNumber) {
    swal.fire({
      title: 'Group ID Required!',
      text: 'Please ensure Group ID is provided.',
      icon: 'error',
      showConfirmButton: false,
      timer: 3000
    });
    return null;
  }

  return {
    groupNumber,
    clientId: this.authService.clientId,
    planType,
    network,
    formType,
    patientId,
    officeId: this.officeId,
    planCreation: this.planCreation,
    planName,
    payerId: this.PayerId,
    benefitDomain: this.benefitDomain,
    // A plan update can create or resubmit the matching domain audit.
    // Do not submit an incomplete verification by default.
    submitForAudit: !!this.activeAuditChangeRequest ||
      (this.verificationData || []).some((row: any) =>
        row?.eligibilityEnum === 'FULL_VERIFICATION' && row?.verificationStatus === 'VERIFIED'),
    insuranceSelection: this.buildAuditSubmissionPayload().insuranceSelection,
    auditPriority: this.buildAuditSubmissionPayload().priority,
    deductible: this.buildDeductiblePayload(),
    coinsurance: this.buildCoinsurancePayload(),
    ortho: this.buildOrthoPayload()

  };
  }
  private buildDeductiblePayload(): any[] {
  return (this.maximumInput?.controls ?? []).map((ctrl, index) => {
    const q = this.maxData[index];

    return {
      id: q?.id ?? null,
      planInfo: q?.name ?? null,
      network: this.patientForm.controls.networkType.value ?? null,
      coverageLevel: ctrl.get('maxCoverage')?.value ?? null,
      planPeriod: ctrl.get('maxPlan')?.value ?? null,
      amount: ctrl.get('maxInput')?.value ?? null
    };
  });
  }
  private buildCoinsurancePayload(): any[] {
  const fromCoinsurance = (this.coinsurances?.controls ?? []).map((ctrl, index) => {
    const q = this.coinsuranceData[index];
    return {
      id: q?.id ?? null,
      serviceName: q?.serviceName ?? null,
      percent: ctrl.get('percent')?.value ?? null,
      limitation: null,                         // coinsurance doesn’t use frequency in your old payload
      disclaimers: null,                        // coinsurance doesn’t use guidelines in your old payload
      age: null,
      waitingPeriod: ctrl.get('waitingPeriod')?.value ?? null,       // OPTIONAL (only if backend supports)
      deductibleApplies: ctrl.get('deductible')?.value ?? null,       // OPTIONAL (only if backend supports)
    };
  });

  const fromCoverage = (this.procedures?.controls ?? []).map((ctrl, index) => {
    const q = this.coveragesData[index];
    return {
      id: q?.id ?? null,
      serviceName: q?.serviceName ?? null,
      percent: ctrl.get('percentage')?.value ?? null,
      limitation: ctrl.get('frequency')?.value ?? null,
      disclaimers: ctrl.get('guidelines')?.value ?? null,
      age: ctrl.get('agelowvalue')?.value ?? null
    };
  });

  // ✅ merged array
  return [...fromCoinsurance, ...fromCoverage];
  }
  private buildOrthoPayload(): any[] {
  return (this.orthos?.controls ?? []).map((ctrl, index) => {
    const q = this.orthoData[index];
    return {
      id: q?.id ?? null,
      serviceName: q?.serviceName ?? null,
      disclaimers: ctrl.get('orthoGuidelines')?.value ?? null,
      percent: ctrl.get('orthoPercent')?.value ?? null,
      limitation: ctrl.get('orthoFrequency')?.value ?? null,
      age: ctrl.get('age')?.value ?? null
    };
  });
  }

  // Submit Insurance to verify
  async onSubmitCombinedDental(): Promise<'success' | 'error'> {
  if (!this.coinsuranceForm.valid || !this.insuranceCoveragesForm.valid || !this.orthoForm.valid) {
    this.sectionResults.coinsurance = 'error';
    this.sectionResults.coverage = 'error';
    this.sectionResults.ortho = 'error';
    return 'error';
  }

  const params = this.buildCommonParams();
  if (!params) return 'error';

  const payload = {};

  try {
    const response: any = await this.insuranceService
      .submitCombinedInsurance(params, { domain: this.benefitDomain })
      .pipe(first())
      .toPromise();

    const planName = response?.planName ?? null;
    if (planName) {
      this.patientForm.get('planName')?.setValue(planName);
      this.patientForm.get('planName')?.markAsPristine();
    }
    if (params.submitForAudit && response?.auditSubmission) {
      this.auditSubmissionSent = true;
      this.activeAuditChangeRequest = null;
    }

    // ✅ save patient silently so it doesn't kill other popups
    await this.onSubmitPatient(true);

    this.sectionResults.coinsurance = 'success';
    this.sectionResults.coverage = 'success';
    this.sectionResults.ortho = 'success';

    return 'success';
  } catch (e) {
    this.sectionResults.coinsurance = 'error';
    this.sectionResults.coverage = 'error';
    this.sectionResults.ortho = 'error';
    return 'error';
  }
  }

  async onSubmitInsurance(): Promise<void> {
    if (this.insuranceVerifyForm.valid) {
      const insuranceData = this.proceduresData.map((procedure: any, index: number) => {
        const feild = this.proceduresInput.at(index).get('procedureInput')?.value;
        return {
          serviceType: procedure.question,
          response: feild,
        };
      });

      const patientId = this.patientId;
      const formType = this.patientForm.controls.formType.value;

      if (!patientId) {
        swal.fire({
          title: 'Patient ID Required!',
          text: 'Please ensure Patient ID is provided.',
          icon: 'error',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }

      // console.log('Insurance data ready for submission:', insuranceData);

      try {
        const response = this.InsuranceExists
          ? await this.insuranceService.updateProcedureData(insuranceData, { patientId, isAdditionalInfo: true, formType, officeId: this.officeId, planCreation: this.planCreation }).pipe(first()).toPromise()
          : await this.insuranceService.submitProcedureData(insuranceData, { patientId, isAdditionalInfo: true, formType, officeId: this.officeId, planCreation: this.planCreation }).pipe(first()).toPromise();

        // console.log('Insurance Form Submitted successfully:', response);
        this.notify({
          title: 'Success!',
          text: 'Data updated successfully!',
          icon: 'success',
          showConfirmButton: false,
          timer: 3000
        });
        // this.checkInsuranceAllFieldsStatus();
        this.sectionResults.appointment = 'success';
        // console.log('called Appointment Info Succesfully');
      } catch (error) {
        console.error('Error updating form:', error);
        this.notify({
          title: 'Error!',
          text: 'Failed to update data.',
          icon: 'error',
          showConfirmButton: false,
          timer: 3000
        });  0
        this.sectionResults.appointment = 'error';
      }
    } else {
      this.notify({
        title: 'Invalid Form!',
        text: 'Please ensure all required fields are filled correctly.',
        icon: 'error',
        showConfirmButton: false,
        timer: 3000
      });
      this.sectionResults.appointment = 'error';
    }
  }

  // Submit History
  async onSubmitHistory(): Promise<void> {
    if (this.historyForm.valid) {
      const histData = this.historyData.map((procedure: any, index: number) => {
        const feild = this.historiesInput.at(index).get('historyInput')?.value;
        const hEligible = this.historiesInput.at(index).get('historyEligibility')?.value;
        return {
          serviceName: procedure.serviceName,
          response: feild,
          eligible: hEligible
        };
      });

      const patientId = this.patientId;
      const clientId = this.authService.clientId;
      const formType = this.patientForm.controls.formType.value;

      if (!patientId) {
        this.notify({
          title: 'Patient ID Required!',
          text: 'Please ensure Patient ID is provided.',
          icon: 'error',
          showConfirmButton: false,
          timer: 3000
        });
        return;
      }

      // console.log('Insurance data ready for submission:', histData);

      try {
        const response = this.historyExists
          ? await this.insuranceService.updateHistoryData(histData, { patientId, clientId, isHistory: true, formType, officeId: this.officeId, planCreation: this.planCreation }).pipe(first()).toPromise()
          : await this.insuranceService.updateHistoryData(histData, { patientId, clientId, isHistory: true, formType, officeId: this.officeId, planCreation: this.planCreation }).pipe(first()).toPromise();

        // console.log('Insurance Form Updated successfully:', response);
        this.notify({
          title: 'Success!',
          text: 'Data submitted successfully!',
          icon: 'success',
          showConfirmButton: false,
          timer: 3000
        });
        // this.checkHistAllFieldsStatus();
        this.sectionResults.history = 'success';
        // console.log('called HX Succesfully');
      } catch (error) {
        console.error('Error submitting form:', error);
        this.notify({
          title: 'Error!',
          text: 'Failed to submit data.',
          icon: 'error',
          showConfirmButton: false,
          timer: 3000
        });
        this.sectionResults.history = 'error';
      }
    } else {
      this.notify({
        title: 'Invalid Form!',
        text: 'Please ensure all required fields are filled correctly.',
        icon: 'error',
        showConfirmButton: false,
        timer: 3000
      });
      this.sectionResults.history = 'error';
    }
  }

  private notify(cfg: SweetAlertOptions, force = false) {
    if (force ) {
      swal.fire(cfg);
    }
  }
}




